/* ANEMOIA HUMAN.EXE. Generated by docs/anemoia-fight/build.mjs; edit the source there, not this file. */
(() => {
// Pure simulation: no browser dependencies. World coordinates are 1280 x 720.
// One mode only: the player is always Neo (slot 0), the CPU is always the Agent (slot 1).
const WORLD = { width: 1280, height: 720, floor: 573, left: 95, right: 1185 };
// Portrait phones only see the middle of the world, so the fight is kept there.
const NARROW = { left: 320, right: 960 };
// The arena changes every round; nobody has to choose one.
const STAGES = [
  { id: 'construct', name: 'THE CONSTRUCT' },
  { id: 'terminal', name: 'TERMINAL 404' },
  { id: 'dojo', name: 'THE DOJO' },
];
// Neo's powers: things only people have made. Three are dealt from this pool,
// and a used one is replaced by a card that is not already in the hand.
const POWERS = {
  wave: { name: 'THE GREAT WAVE', by: 'HOKUSAI / 1831', color: '#7fc4ff' },
  starry: { name: 'THE STARRY NIGHT', by: 'VAN GOGH / 1889', color: '#ffd84a' },
  fifth: { name: 'SYMPHONY NO. 5', by: 'BEETHOVEN / 1808', color: '#ffe9b8' },
  vitruvian: { name: 'VITRUVIAN MAN', by: 'DA VINCI / c.1490', color: '#e0b27a' },
  scream: { name: 'THE SCREAM', by: 'MUNCH / 1893', color: '#ff7a3d' },
  hands: { name: 'CAVE OF HANDS', by: 'THE FIRST ARTISTS / 9,000+ YEARS AGO', color: '#e0703a' },
};
const POWER_IDS = Object.keys(POWERS);
const METER_MAX = 99, POWER_COST = 33, FINISH_AT = 25, ROUND_TIME = 60;
const MOVES = {
  light: { damage: 6, range: 138, startup: .09, active: .1, duration: .3, push: 18, stun: .24, rank: 1 },
  heavy: { damage: 10, range: 176, startup: .16, active: .12, duration: .46, push: 46, stun: .36, rank: 2 },
  air: { damage: 9, range: 160, startup: .08, active: .16, duration: .4, push: 30, stun: .3, rank: 2 },
  special: { damage: 13, range: 420, startup: .3, active: .16, duration: .8, push: 60, stun: .45, rank: 3, cost: 34 },
  super: { damage: 24, range: 620, startup: .45, active: .22, duration: 1.25, push: 110, stun: .8, rank: 4, cost: 100 },
  power: { damage: 22, range: 9999, startup: .75, active: .2, duration: 1.7, push: 90, stun: 1.1, rank: 5 },
};
const MOVE_NAMES = { light: 'JAB', heavy: 'KICK', air: 'FLYING KICK', special: 'SIDEARM', super: 'REPLICATE' };
const EMPTY_INPUT = Object.freeze({ left: false, right: false, block: false, pressed: [] });
// Bullet time: Neo leans back under a hit. Timed right, time slows and he earns power.
const DODGE = Object.freeze({ duration: .52, activeFrom: .06, activeTo: .36, cooldown: 1.1, reward: 12 });
const clamp = (v, a, b) => Math.max(a, Math.min(b, v));

function fighter(kind, slot) {
  return { kind, slot, x: slot ? 925 : 355, y: 0, vy: 0, facing: slot ? -1 : 1, health: 100, meter: 0, wins: 0,
    action: null, chain: 0, chainTimer: 0, stun: 0, block: false, moving: 0, hitFlash: 0, combo: 0, comboTimer: 0,
    history: [], prediction: 0, aiClock: .8, guardTimer: 0, predictedGuard: false, verdict: '', verdictTime: 0, buffer: null, derez: 0, dodge: null, dodgeCooldown: 0 };
}

class Match {
  constructor({ narrow = false, difficulty = 1, rng = Math.random } = {}) {
    this.rng = rng; this.difficulty = difficulty;
    this.bounds = narrow ? NARROW : WORLD;
    this.fighters = [fighter('human', 0), fighter('machine', 1)];
    this.place();
    this.round = 1; this.timer = ROUND_TIME; this.phase = 'intro'; this.phaseTime = 2.2; this.elapsed = 0;
    this.events = []; this.winner = null; this.roundWinner = null; this.hitstop = 0; this.slowMotion = 0;
    this.hand = this.deal(); this.critical = false; this.finisher = null; this.lastPower = null;
  }
  get stage() { return STAGES[(this.round - 1) % STAGES.length].id; }
  place() {
    const { left, right } = this.bounds, span = right - left;
    this.fighters[0].x = left + span * .28; this.fighters[1].x = left + span * .72;
  }
  deal() {
    const pool = [...POWER_IDS];
    for (let i = pool.length - 1; i > 0; i--) { const j = Math.floor(this.rng() * (i + 1)); [pool[i], pool[j]] = [pool[j], pool[i]]; }
    return pool.slice(0, 3);
  }
  emit(type, data = {}) { this.events.push({ type, ...data }); }
  drainEvents() { return this.events.splice(0); }
  resetRound() {
    this.fighters = this.fighters.map((f, i) => ({ ...fighter(f.kind, i), wins: f.wins, meter: Math.min(f.meter, i === 0 ? POWER_COST : 50), history: f.history.slice(-6) }));
    this.place();
    this.round++; this.timer = ROUND_TIME; this.phase = 'intro'; this.phaseTime = 2; this.slowMotion = 0;
    this.hand = this.deal(); this.critical = false; this.finisher = null;
    this.emit('round', { round: this.round }); this.emit('hand', { hand: this.hand });
  }
  // Remember what the human does, and guard when it becomes a pattern.
  record(f, key) {
    const recent = f.history.filter(h => this.elapsed - h.time < 15).slice(-8);
    const repetitions = recent.filter(h => h.key === key).length;
    const previous = recent.at(-1)?.key;
    let sequenceRepeats = 0;
    for (let i = 1; i < recent.length; i++) if (recent[i - 1].key === previous && recent[i].key === key) sequenceRepeats++;
    const predictability = clamp(Math.max(repetitions - 1, sequenceRepeats) / 4, 0, 1);
    f.prediction = predictability;
    f.history.push({ key, time: this.elapsed }); f.history = f.history.slice(-14);
    return { predictability, repetitions, varied: recent.length > 0 && !recent.slice(-3).some(h => h.key === key) };
  }
  startAttack(f, type) {
    const m = MOVES[type];
    if (!m || this.phase !== 'fight' || f.stun > 0 || f.action) return false;
    if (m.cost && f.meter < m.cost) return false;
    const stance = f.y > 30 ? 'air' : 'stand';
    const key = `${stance}:${type}`;
    const { predictability, repetitions, varied } = this.record(f, key);
    if (m.cost) f.meter -= m.cost;
    f.action = { type, key, stance, time: 0, move: m, resolved: false, connected: false, varied };
    const other = this.fighters[1 - f.slot];
    if (f.kind === 'human' && predictability >= .25 && other.stun <= 0 && other.y === 0 && !other.action && Math.abs(f.x - other.x) < m.range + 110) {
      if (this.rng() < (.5 + predictability * .45) * this.difficulty) {
        other.guardTimer = m.startup + m.active + .12; other.predictedGuard = true;
        other.verdict = repetitions >= 4 ? 'BEHAVIOR LEARNED' : 'PATTERN DETECTED'; other.verdictTime = 1.2;
        this.emit('pattern', { slot: other.slot, text: other.verdict });
      }
    }
    this.emit('attack', { slot: f.slot, kind: f.kind, move: type });
    if (type === 'super') this.emit('super', { slot: f.slot, kind: f.kind });
    return true;
  }
  // One strike button: jab, jab, kick. In the air it is a flying kick.
  strike(f) {
    if (f.y > 30) return this.startAttack(f, 'air');
    const step = f.chainTimer > 0 ? f.chain : 0;
    if (!this.startAttack(f, step >= 2 ? 'heavy' : 'light')) return false;
    f.chain = step >= 2 ? 0 : step + 1; f.chainTimer = .75;
    return true;
  }
  startDodge(f) {
    if (this.phase !== 'fight' || f.kind !== 'human' || f.y > 0 || f.stun > 0 || f.action || f.dodge || f.dodgeCooldown > 0) return false;
    f.dodge = { time: 0, successful: false }; f.dodgeCooldown = DODGE.cooldown;
    f.block = false; f.buffer = null; f.moving = 0;
    this.emit('dodge', { slot: f.slot });
    return true;
  }
  usePower(f, slot) {
    const id = this.hand[slot];
    if (!id || f.kind !== 'human' || this.phase !== 'fight' || f.stun > 0 || f.action || f.meter < POWER_COST) return false;
    const other = this.fighters[1];
    f.meter -= POWER_COST;
    const finishing = other.health <= FINISH_AT;
    // A finisher plays the art out slower, so it can be read and felt before the K.O.
    const move = finishing ? { ...MOVES.power, startup: 1.5, duration: 3.4 } : MOVES.power;
    f.action = { type: 'power', key: `power:${id}`, stance: 'stand', power: id, time: 0, move, resolved: false, connected: false, finishing };
    f.chain = 0; f.y = 0; f.vy = 0;
    // The machine has no answer to it: it freezes for the whole piece.
    other.action = null; other.guardTimer = 0; other.predictedGuard = false; other.stun = move.duration;
    this.record(f, f.action.key);
    this.lastPower = id;
    const pool = POWER_IDS.filter(p => !this.hand.includes(p));
    this.hand = this.hand.map((p, i) => i === slot ? pool[Math.floor(this.rng() * pool.length)] : p);
    this.emit('power', { power: id, finishing, x: other.x });
    this.emit('hand', { hand: this.hand, slot });
    return true;
  }
  resolveHit(f, other) {
    const a = f.action, m = a.move;
    if (a.type !== 'power') {
      if (Math.abs(f.x - other.x) > m.range || Math.abs(f.y - other.y) > (a.type === 'super' ? 260 : a.type === 'special' ? 140 : 100)) return;
      if (other.action?.type === 'super' && other.action.time < .25) return;
    }
    a.resolved = true;
    if (a.type !== 'power' && other.dodge && other.dodge.time >= DODGE.activeFrom && other.dodge.time <= DODGE.activeTo) {
      if (!other.dodge.successful) {
        other.dodge.successful = true;
        other.meter = clamp(other.meter + DODGE.reward, 0, METER_MAX); this.slowMotion = .45;
        other.verdict = 'BULLET TIME'; other.verdictTime = 1.1;
        this.emit('evade', { slot: other.slot, x: other.x, y: WORLD.floor - 170, move: a.type });
      }
      return;
    }
    const front = (f.x - other.x) * other.facing >= 0;
    const guarding = a.type !== 'power' && other.block && front && other.y === 0 && !other.action && other.stun <= 0;
    if (guarding) {
      other.health = Math.max(1, other.health - (a.type === 'super' ? 5 : a.type === 'special' ? 2 : 0));
      const predicted = other.predictedGuard;
      other.meter = clamp(other.meter + (predicted ? 17 : 6), 0, 100);
      other.x = clamp(other.x + f.facing * m.push * .4, this.bounds.left, this.bounds.right);
      other.verdict = predicted ? 'PREDICTED' : 'BLOCK'; other.verdictTime = .85;
      this.emit('block', { x: (f.x + other.x) / 2, y: WORLD.floor - 137 - other.y, slot: other.slot, kind: f.kind, move: a.type, predicted });
      this.hitstop = .025; other.predictedGuard = false;
      if (predicted) other.aiClock = .08;
      return;
    }
    let damage = Math.round(m.damage * (a.varied ? 1.15 : 1) * (f.combo > 2 ? .85 : 1));
    if (a.type === 'power' && (a.finishing || other.health <= damage)) damage = other.health;
    other.health = clamp(other.health - damage, 0, 100); other.stun = Math.max(other.stun, m.stun); other.action = null; other.block = false; other.dodge = null;
    other.hitFlash = .16; other.guardTimer = 0; other.predictedGuard = false; other.chain = 0;
    other.x = clamp(other.x + f.facing * m.push, this.bounds.left, this.bounds.right);
    if (a.type === 'air' || a.type === 'heavy') { other.vy = a.type === 'air' ? 260 : 180; other.y = Math.max(1, other.y); }
    a.connected = true;
    f.combo = f.comboTimer > 0 ? f.combo + 1 : 1; f.comboTimer = 1.05;
    if (f.kind === 'human') { if (a.type !== 'power') f.meter = clamp(f.meter + 7 + (a.varied ? 5 : 0), 0, METER_MAX); }
    else f.meter = clamp(f.meter + 6, 0, 100);
    if (other.kind === 'human') other.meter = clamp(other.meter + 4, 0, METER_MAX); else other.meter = clamp(other.meter + damage * .3, 0, 100);
    this.emit('hit', { x: other.x, y: WORLD.floor - 135 - other.y, slot: f.slot, kind: f.kind, damage, move: a.type, combo: f.combo, varied: a.varied, power: a.power });
    this.hitstop = a.type === 'super' || a.type === 'power' ? .12 : a.type === 'heavy' ? .06 : .035;
    if (a.type === 'power' && other.health <= 0) {
      this.finisher = { power: a.power, time: 0 };
      this.phase = 'finisher'; this.phaseTime = 4.8; this.roundWinner = f.slot; f.wins++;
      other.derez = .001;
      this.emit('finisher', { power: a.power, x: other.x, y: WORLD.floor - 135 });
    }
  }
  aiInput(dt) {
    const cpu = this.fighters[1], p = this.fighters[0], distance = Math.abs(cpu.x - p.x);
    cpu.aiClock -= dt;
    const input = { left: false, right: false, block: false, pressed: [] };
    const aggression = (.8 + (this.round - 1) * .12) * this.difficulty;
    if (cpu.guardTimer > 0 && !cpu.action) input.block = true;
    if (!cpu.action && cpu.stun <= 0 && !input.block) {
      if (distance > 150) { input.left = cpu.x > p.x; input.right = cpu.x < p.x; }
      if (distance < 85 && cpu.aiClock > .3) { input.left = cpu.x < p.x; input.right = cpu.x > p.x; }
      if (cpu.aiClock <= 0) {
        cpu.aiClock = (.42 + this.rng() * .55) / aggression;
        const choice = this.rng();
        if (cpu.meter >= 100 && distance < 560 && choice < .6) input.pressed.push('super');
        else if (cpu.meter >= 34 && distance > 190 && distance < 400 && choice < .55) input.pressed.push('special');
        else if (distance < 180) input.pressed.push(choice < .6 ? 'light' : 'heavy');
      }
    }
    return input;
  }
  tick(dt, input = EMPTY_INPUT) {
    dt = Math.min(Math.max(dt, 0), .05);
    if (this.phase === 'matchEnd') return;
    if (this.slowMotion > 0) { this.slowMotion = Math.max(0, this.slowMotion - dt); dt *= .35; }
    if (this.hitstop > 0) {
      if (input.pressed?.includes('strike')) this.fighters[0].buffer = { type: 'strike', life: .2 };
      this.hitstop = Math.max(0, this.hitstop - dt); return;
    }
    this.elapsed += dt;
    if (this.phase === 'finisher') {
      this.finisher.time += dt; this.phaseTime -= dt;
      const [p, cpu] = this.fighters;
      if (this.finisher.time > .7) cpu.derez = Math.min(1, cpu.derez + dt / 2.2);
      if (p.action) { p.action.time += dt; if (p.action.time >= p.action.move.duration) p.action = null; }
      if (this.phaseTime <= 0) this.endRound(1.4);
      return;
    }
    if (this.phase !== 'fight') {
      this.phaseTime -= dt;
      if (this.phaseTime <= 0) {
        if (this.phase === 'intro') { this.phase = 'fight'; this.emit('fight'); }
        else if (this.fighters.some(f => f.wins >= 2)) {
          this.phase = 'matchEnd'; this.winner = this.fighters.findIndex(f => f.wins >= 2); this.emit('matchEnd', { winner: this.winner });
        } else this.resetRound();
      }
      return;
    }
    this.timer = Math.max(0, this.timer - dt);
    const controls = [input, this.aiInput(dt)];
    this.fighters.forEach((f, i) => {
      const c = controls[i]; const other = this.fighters[1 - i];
      f.hitFlash = Math.max(0, f.hitFlash - dt); f.verdictTime = Math.max(0, f.verdictTime - dt);
      f.stun = Math.max(0, f.stun - dt); f.guardTimer = Math.max(0, f.guardTimer - dt);
      f.chainTimer = Math.max(0, f.chainTimer - dt); f.dodgeCooldown = Math.max(0, f.dodgeCooldown - dt);
      if (f.dodge) { f.dodge.time += dt; if (f.dodge.time >= DODGE.duration) f.dodge = null; }
      if (f.guardTimer === 0) f.predictedGuard = false;
      f.comboTimer = Math.max(0, f.comboTimer - dt); if (!f.comboTimer) f.combo = 0;
      if (!f.action && !f.dodge) f.facing = other.x > f.x ? 1 : -1;
      if (f.y > 0 || f.vy > 0) { f.y += f.vy * dt; f.vy -= 1550 * dt; if (f.y <= 0) { f.y = 0; f.vy = 0; } }
      f.block = !!c.block && !f.action && !f.dodge && f.stun === 0 && f.y === 0;
      f.moving = 0;
      if (f.stun > 0) { f.buffer = null; return; }
      const pressed = c.pressed || [];
      if (i === 0 && pressed.includes('dodge')) this.startDodge(f);
      if (f.dodge) { f.buffer = null; return; }
      if (pressed.includes('jump') && f.y === 0 && !f.action) { f.vy = 640; f.y = 1; this.emit('jump', { slot: i }); }
      if (!f.action && !f.block) {
        f.moving = Number(!!c.right) - Number(!!c.left);
        f.x = clamp(f.x + f.moving * (f.kind === 'human' ? 285 : 245) * dt, this.bounds.left, this.bounds.right);
      }
      if (i === 0) {
        const power = pressed.find(k => k.startsWith('power:'));
        if (power) this.usePower(f, Number(power.slice(6)));
        if (pressed.includes('strike')) f.buffer = { type: 'strike', life: .2 };
        if (f.buffer) { f.buffer.life -= dt; if (this.strike(f) || f.buffer.life <= 0) f.buffer = null; }
      } else {
        const attack = pressed.find(k => MOVES[k]);
        if (attack) this.startAttack(f, attack);
      }
    });
    for (const f of this.fighters) if (f.action) {
      const a = f.action; a.time += dt;
      if (!a.resolved && a.time >= a.move.startup && a.time <= a.move.startup + a.move.active) this.resolveHit(f, this.fighters[1 - f.slot]);
      if (this.phase !== 'fight') return;
      if (a.time >= a.move.duration) f.action = null;
    }
    const [a, b] = this.fighters;
    if (Math.abs(a.x - b.x) < 75 && Math.abs(a.y - b.y) < 110) {
      const sign = a.x <= b.x ? -1 : 1, overlap = (75 - Math.abs(a.x - b.x)) / 2;
      a.x = clamp(a.x + sign * overlap, this.bounds.left, this.bounds.right); b.x = clamp(b.x - sign * overlap, this.bounds.left, this.bounds.right);
    }
    // The Agent is on the edge: tell the human their art can end it.
    const critical = b.health > 0 && b.health <= FINISH_AT;
    if (critical && !this.critical) this.emit('critical');
    this.critical = critical;
    if (a.health <= 0 || b.health <= 0 || this.timer <= 0) {
      this.roundWinner = a.health === b.health ? null : a.health > b.health ? 0 : 1;
      if (this.roundWinner !== null) this.fighters[this.roundWinner].wins++;
      this.emit('ko', { winner: this.roundWinner, timeout: this.timer <= 0 });
      this.endRound();
    }
  }
  endRound(time = 2.6) {
    this.phase = 'roundEnd'; this.phaseTime = time;
    this.fighters.forEach(f => { f.action = null; f.block = false; f.dodge = null; });
  }
}


// Phosphor green is the system; the red-pill pink belongs to the human.
const GREEN = '#6dff8a', MINT = '#55ff8a', PILL = '#ff4fc3';
const SHARDS = ['#ff4fc3', '#ffffff', '#ff9ad9', '#6dff8a', '#ff8a5c'];
const GLYPHS = '01アリスヲネムハミヒーウシナモニサワツオリアホテマケメエカキムユラセネスタヌヘ<>/{}ΞΔ';
const TAU = Math.PI * 2;
const mix = (a, b, t) => a + (b - a) * t;
const noise = n => { const v = Math.sin(n * 127.1 + 311.7) * 43758.5453; return v - Math.floor(v); };
const glyph = n => GLYPHS[Math.floor(noise(n) * GLYPHS.length)];

class Renderer {
  constructor(canvas) {
    this.canvas = canvas; this.ctx = canvas.getContext('2d', { alpha: false });
    this.time = 0; this.particles = []; this.labels = []; this.rings = []; this.shake = 0; this.flash = 0; this.superFlash = 0; this.superKind = 'machine'; this.reduced = false;
    this.powerFx = null; this.koFx = null; this.zoom = 1; this.evadeFlash = 0; this.evadeY = 400;
    this.resize();
  }
  resize() {
    const dpr = Math.min(window.devicePixelRatio || 1, 1.6);
    const width = this.canvas.clientWidth, height = this.canvas.clientHeight;
    this.canvas.width = Math.round(width * dpr); this.canvas.height = Math.round(height * dpr);
    this.scaleX = this.canvas.width / 1280; this.scaleY = this.canvas.height / 720;
  }
  poly(points, fill, stroke, width = 1) {
    const c = this.ctx; c.beginPath(); points.forEach(([x, y], i) => i ? c.lineTo(x, y) : c.moveTo(x, y)); c.closePath();
    if (fill) { c.fillStyle = fill; c.fill(); } if (stroke) { c.strokeStyle = stroke; c.lineWidth = width; c.stroke(); }
  }
  line(points, color, width = 1) {
    const c = this.ctx; c.beginPath(); points.forEach(([x, y], i) => i ? c.lineTo(x, y) : c.moveTo(x, y));
    c.strokeStyle = color; c.lineWidth = width; c.stroke();
  }
  text(text, x, y, size = 10, color = GREEN) {
    const c = this.ctx; c.fillStyle = color; c.font = `${size}px Consolas, monospace`; c.fillText(text, x, y);
  }
  ring(x, y, rx, ry, color, width = 2) {
    const c = this.ctx; c.beginPath(); c.ellipse(x, y, Math.max(.1, rx), Math.max(.1, ry), 0, 0, TAU); c.strokeStyle = color; c.lineWidth = width; c.stroke();
  }
  glow(color, blur = 12) { if (!this.reduced) { this.ctx.shadowColor = color; this.ctx.shadowBlur = blur; } }
  clearGlow() { this.ctx.shadowBlur = 0; }
  portrait(canvas, kind) {
    const original = this.ctx; this.ctx = canvas.getContext('2d'); const c = this.ctx;
    c.clearRect(0, 0, canvas.width, canvas.height); c.save();
    c.fillStyle = kind === 'human' ? '#2a0f22' : '#0b2515'; c.fillRect(0, 0, canvas.width, canvas.height);
    c.translate(canvas.width / 2, 318); c.scale(1.25, 1.25); c.translate(0, -WORLD.floor);
    this.fighter({ kind, x: 0, y: 0, facing: 1, stun: 0, moving: 0, hitFlash: 0 }, 0, { ghost: true });
    c.restore(); this.ctx = original;
  }
  // The awakened glow: falling glyphs bend around him, with a red-pill rim.
  codeAura(t, intensity, color) {
    const c = this.ctx;
    c.save();
    const aura = c.createRadialGradient(1, -134, 23, 1, -134, 162);
    aura.addColorStop(0, `${color}24`); aura.addColorStop(.55, '#6dff8a0a'); aura.addColorStop(1, '#6dff8a00');
    c.fillStyle = aura; c.fillRect(-170, -300, 340, 330);
    c.font = '12px Consolas, monospace';
    for (let i = 0; i < 7; i++) {
      const x = -84 + i * 28, speed = 40 + noise(i + 3) * 50;
      for (let k = 0; k < 6; k++) {
        const y = ((t * speed + noise(i) * 300 + k * 17) % 300) - 290;
        const bend = Math.sin((y + 150) / 60) * 14 * (Math.abs(x) < 60 ? 1 : .3);
        c.globalAlpha = (k / 6) * (.1 + intensity * .35) * (this.reduced ? .5 : 1);
        c.fillStyle = k === 5 ? '#e8fff0' : '#6dff8a';
        c.fillText(glyph(i * 11 + k + Math.floor(t * 3)), x + bend, y);
      }
    }
    c.restore();
  }
  // Human strike effects. `tip` is the striking hand or foot in local coordinates.
  martialAttack(a, p, strike, tip) {
    const c = this.ctx, strength = Math.sin(Math.min(1, p) * Math.PI);
    c.save(); c.globalAlpha = strength * .95; c.lineCap = 'round'; this.glow(PILL, 12);
    const [tx, ty] = tip;
    if (a.type === 'light') {
      for (let j = 0; j < 3; j++) this.line([[tx - 46 - j * 12, ty - 8 + j * 8], [tx - 6, ty - 3 + j * 3]], j === 1 ? '#ffffff' : PILL, 3 - j * .7);
      c.beginPath(); c.arc(tx + 4, ty, 12 + strike * 16, -1.1, 1.1); c.strokeStyle = '#ffffff'; c.lineWidth = 3; c.stroke();
    } else {
      // Kicks leave a crescent where the leg swept.
      const start = Math.atan2(-10, 50), end = Math.atan2(ty + 91, tx + 8);
      for (let j = 0; j < 3; j++) { c.beginPath(); c.arc(-8, -91, Math.hypot(tx + 8, ty + 91) - j * 12, start - .3, end); c.strokeStyle = j === 1 ? '#ffffff' : PILL; c.lineWidth = 8 - j * 2.5; c.stroke(); }
      this.ring(tx + 6, ty, 10 + strike * 30, 6 + strike * 22, '#ffffff', 2);
    }
    this.clearGlow(); c.restore();
  }
  // The Agent's sidearm: muzzle flash and three rounds that drag rings through the air.
  sidearm(a, p, strike, hand) {
    const c = this.ctx, length = 300, strength = Math.sin(Math.min(1, p) * Math.PI);
    c.save();
    this.poly([[hand[0] - 2, hand[1] - 8], [hand[0] + 26, hand[1] - 8], [hand[0] + 26, hand[1] - 1], [hand[0] + 6, hand[1] - 1], [hand[0] + 4, hand[1] + 10], [hand[0] - 3, hand[1] + 10]], '#111413', '#5c6662', 1);
    if (p > .28 && p < .5) { this.glow('#fff3b0', 16); this.poly([[hand[0] + 27, hand[1] - 5], [hand[0] + 48, hand[1] - 12], [hand[0] + 40, hand[1] - 4], [hand[0] + 54, hand[1] + 2], [hand[0] + 34, hand[1] - 1]], '#fff3b0'); this.clearGlow(); }
    if (p > .3) for (let j = 0; j < 3; j++) {
      const d = Math.min(1, (p - .3 - j * .06) * 2.2); if (d <= 0) continue;
      const x = hand[0] + 30 + d * length, y = hand[1] - 4 + (j - 1) * 5;
      c.globalAlpha = strength;
      this.line([[x - 60, y], [x, y]], '#d9ffe4', 1);
      for (let k = 1; k <= 3; k++) { c.globalAlpha = strength * (.5 - k * .12); this.ring(x - k * 18, y, 2 + k, 5 + k * 3, '#bfffd0', 1); }
      c.globalAlpha = strength; this.poly([[x, y - 2], [x + 9, y - 1.5], [x + 12, y], [x + 9, y + 1.5], [x, y + 2]], '#e8d7a0');
    }
    c.restore();
  }
  // --- Arena art: the same six works hang in the arenas, each framed for its place. ---
  miniArt(id, w, h, t) {
    const c = this.ctx;
    if (id === 'wave') {
      c.fillStyle = '#efe3c6'; c.fillRect(0, 0, w, h);
      this.poly([[w * .5, h * .85], [w * .64, h * .6], [w * .78, h * .85]], '#3b5f8f'); this.poly([[w * .6, h * .66], [w * .64, h * .6], [w * .68, h * .66]], '#fbf6ea');
      c.beginPath(); c.moveTo(0, h); c.bezierCurveTo(w * .1, h * .6, w * .25, h * .12, w * .46, h * .14);
      c.bezierCurveTo(w * .6, h * .15, w * .64, h * .34, w * .54, h * .38); c.bezierCurveTo(w * .48, h * .4, w * .47, h * .3, w * .52, h * .29);
      c.bezierCurveTo(w * .4, h * .36, w * .36, h * .7, w * .44, h); c.closePath(); c.fillStyle = '#24467e'; c.fill();
      for (let i = 0; i < 9; i++) { const a = -2.8 + i * .32; c.fillStyle = '#fbf6ea'; c.beginPath(); c.arc(w * .5 + Math.cos(a) * h * .15, h * .3 + Math.sin(a) * h * .15, 2.5, 0, TAU); c.fill(); }
      for (let j = 1; j < 4; j++) { c.beginPath(); c.moveTo(w * .02 * j, h); c.bezierCurveTo(w * .12, h * .62 + j * 8, w * .26, h * .2 + j * 9, w * .44, h * .18 + j * 8); c.strokeStyle = '#8fb1dd'; c.lineWidth = 1; c.stroke(); }
      c.beginPath(); c.moveTo(w * .7, h); c.quadraticCurveTo(w * .85, h * .7, w, h * .82); c.lineTo(w, h); c.fillStyle = '#24467e'; c.fill();
    } else if (id === 'hands') {
      const g = c.createLinearGradient(0, 0, w, h); g.addColorStop(0, '#6e3d24'); g.addColorStop(1, '#4a2616'); c.fillStyle = g; c.fillRect(0, 0, w, h);
      [[.2, .4, -.3, '#e08a3c'], [.45, .62, .2, '#c4502a'], [.7, .35, .4, '#f0d9a8'], [.82, .72, -.1, '#a33a1f'], [.3, .8, .1, '#c4502a']].forEach(([x, y, r, col]) => this.hand(w * x, h * y, r, h / 260, col));
    } else if (id === 'scream') {
      ['#e8562a', '#f39a3a', '#f5c14d', '#c8372a', '#f39a3a'].forEach((col, j) => { c.beginPath(); for (let x = 0; x <= w; x += 6) c.lineTo(x, h * (.08 + j * .09) + Math.sin(x * .07 + j + t * 1.5) * 4); c.strokeStyle = col; c.lineWidth = h * .1; c.stroke(); });
      ['#27456b', '#3e6d8e', '#1b2d45'].forEach((col, j) => { c.beginPath(); for (let x = 0; x <= w; x += 6) c.lineTo(x, h * (.55 + j * .1) + Math.sin(x * .05 - j) * 5); c.strokeStyle = col; c.lineWidth = h * .11; c.stroke(); });
      this.poly([[0, h], [w * .75, h * .5], [w * .8, h * .55], [w * .1, h]], '#8a5530');
      c.fillStyle = '#1a120c'; c.beginPath(); c.ellipse(w * .45, h * .92, w * .08, h * .16, 0, 0, TAU); c.fill();
      c.fillStyle = '#e6dcc0'; c.beginPath(); c.ellipse(w * .45, h * .72, w * .06, h * .09, 0, 0, TAU); c.fill();
      c.fillStyle = '#2a1d14'; c.beginPath(); c.ellipse(w * .45, h * .76, w * .015, h * .03, 0, 0, TAU); c.fill();
    } else if (id === 'starry') {
      c.fillStyle = '#1a2f6b'; c.fillRect(0, 0, w, h);
      for (let i = 0; i < 40; i++) { const a = i * .38 + t * .6, r = 3 + i * .9; this.line([[w * .45 + Math.cos(a) * r * 1.5, h * .32 + Math.sin(a) * r * .7], [w * .45 + Math.cos(a + .35) * r * 1.5, h * .32 + Math.sin(a + .35) * r * .7]], i % 2 ? '#8fb8e8' : '#e9f0ff', 2); }
      for (const [x, y] of [[.15, .2], [.3, .12], [.72, .18], [.62, .38], [.88, .3]]) { c.fillStyle = 'rgba(245,213,71,.35)'; c.beginPath(); c.arc(w * x, h * y, h * .07, 0, TAU); c.fill(); c.fillStyle = '#ffe36b'; c.beginPath(); c.arc(w * x, h * y, h * .035, 0, TAU); c.fill(); }
      c.fillStyle = '#ffd84a'; c.beginPath(); c.arc(w * .9, h * .12, h * .07, 0, TAU); c.fill();
      c.fillStyle = '#0f1e33'; c.fillRect(0, h * .78, w, h * .22);
      for (let i = 0; i < 7; i++) { c.fillStyle = '#ffd84a'; c.fillRect(w * (.35 + i * .08), h * (.84 + (i % 2) * .05), 3, 3); }
      c.beginPath(); c.moveTo(w * .08, h); c.bezierCurveTo(w * .02, h * .6, w * .12, h * .3, w * .14, h * .12); c.bezierCurveTo(w * .2, h * .4, w * .26, h * .7, w * .22, h); c.fillStyle = '#0a1a10'; c.fill();
    } else if (id === 'vitruvian') {
      c.fillStyle = '#e4d2a8'; c.fillRect(0, 0, w, h);
      const ink = '#5a3b1c', cx = w * .5, cy = h * .52, r = h * .38;
      this.ring(cx, cy, r, r, ink, 1.5); c.strokeStyle = ink; c.lineWidth = 1.5; c.strokeRect(cx - r * .88, cy - r * .78, r * 1.76, r * 1.76);
      c.fillStyle = ink; c.beginPath(); c.arc(cx, cy - r * .62, r * .12, 0, TAU); c.fill();
      this.line([[cx, cy - r * .5], [cx, cy + r * .25]], ink, 2);
      for (const a of [-2.8, -.34, -2.4, -.74]) this.line([[cx, cy - r * .38], [cx + Math.cos(a) * r * .95, cy - r * .38 + Math.sin(a) * r * .5]], ink, 1.5);
      for (const a of [1.95, 1.19, 1.7, 1.44]) this.line([[cx, cy + r * .25], [cx + Math.cos(a) * r * .8, cy + r * .25 + Math.sin(a) * r * .75]], ink, 1.5);
      for (let row = 0; row < 3; row++) { c.beginPath(); for (let x = 0; x < w * .8; x += 3) c.lineTo(w * .1 + x, h * .07 + row * 5 + Math.sin(x) * 1); c.strokeStyle = 'rgba(90,59,28,.6)'; c.lineWidth = 1; c.stroke(); }
    } else if (id === 'fifth') {
      c.fillStyle = '#eadcb8'; c.fillRect(0, 0, w, h);
      c.fillStyle = '#3a2a18'; c.font = `bold ${Math.round(h * .12)}px Georgia, serif`; c.textAlign = 'center'; c.fillText('SINFONIE No. 5', w / 2, h * .16); c.textAlign = 'left';
      for (let sys = 0; sys < 2; sys++) {
        const top = h * (.3 + sys * .35);
        for (let j = 0; j < 5; j++) this.line([[w * .06, top + j * h * .045], [w * .94, top + j * h * .045]], '#6b5638', 1);
        [.2, .34, .48].forEach(x => this.note(w * x, top + h * .12, h * .2, '#1a120a'));
        c.fillStyle = '#1a120a'; c.beginPath(); c.ellipse(w * .72, top + h * .16, h * .04, h * .028, -.35, 0, TAU); c.fill(); this.line([[w * .72 + h * .035, top + h * .16], [w * .72 + h * .035, top - h * .02]], '#1a120a', 1.5);
      }
    }
  }
  artFrame(id, x, y, w, h, style, t) {
    const c = this.ctx;
    c.save();
    if (style === 'scroll') {
      // Hanging scroll: cord, rods, paper mount.
      this.line([[x + w * .2, y - 8], [x + w / 2, y - 34], [x + w * .8, y - 8]], '#6b5a3a', 1.5);
      c.fillStyle = '#0006'; c.fillRect(x + 6, y + 6, w, h + 16);
      c.fillStyle = '#d9d3bb'; c.fillRect(x, y, w, h + 16);
      c.save(); c.translate(x + 10, y + 12); c.beginPath(); c.rect(0, 0, w - 20, h - 8); c.clip(); this.miniArt(id, w - 20, h - 8, t); c.restore();
      c.fillStyle = '#3a2c1c'; c.fillRect(x - 8, y - 8, w + 16, 9); c.fillRect(x - 8, y + h + 12, w + 16, 10);
      c.fillStyle = '#6b5a3a'; c.fillRect(x - 12, y - 7, 5, 7); c.fillRect(x + w + 7, y - 7, 5, 7);
    } else if (style === 'poster') {
      // Backlit station poster behind scratched glass.
      c.fillStyle = '#0a1a10'; c.fillRect(x - 8, y - 8, w + 16, h + 30);
      this.glow('#9dffb0', 18); c.strokeStyle = '#6fa87c'; c.lineWidth = 2; c.strokeRect(x - 8, y - 8, w + 16, h + 30); this.clearGlow();
      c.save(); c.beginPath(); c.rect(x, y, w, h); c.clip(); c.translate(x, y); this.miniArt(id, w, h, t); c.restore();
      c.globalAlpha = .1; this.poly([[x + w * .15, y], [x + w * .45, y], [x + w * .1, y + h], [x - w * .2, y + h]], '#ffffff'); c.globalAlpha = 1;
      // The caption has to fit inside the frame: drop the line number, then shrink.
      c.font = '9px Consolas, monospace'; let label = `${POWERS[id].name} / LINE 404`, size = 9;
      if (c.measureText(label).width > w + 8) label = POWERS[id].name;
      while (size > 6 && (c.font = `${size}px Consolas, monospace`, c.measureText(label).width > w + 8)) size--;
      c.textAlign = 'center'; this.text(label, x + w / 2, y + h + 15, size, '#8fc89b'); c.textAlign = 'left';
    } else {
      // Construct hologram: tinted, scanned, flickering, with bracket corners.
      const flicker = .55 + Math.sin(t * 9 + x) * .06 + (noise(Math.floor(t * 6) + x) > .93 ? -.3 : 0);
      c.save(); c.globalAlpha = flicker; c.beginPath(); c.rect(x, y, w, h); c.clip(); c.translate(x, y); this.miniArt(id, w, h, t);
      c.fillStyle = 'rgba(40,255,110,.22)'; c.fillRect(0, 0, w, h);
      c.fillStyle = 'rgba(0,20,8,.35)'; for (let sy = 0; sy < h; sy += 3) c.fillRect(0, sy, w, 1);
      c.restore();
      this.glow('#55ff8a', 12);
      for (const [cx, cy, dx, dy] of [[x, y, 1, 1], [x + w, y, -1, 1], [x, y + h, 1, -1], [x + w, y + h, -1, -1]]) this.line([[cx + dx * 18, cy], [cx, cy], [cx, cy + dy * 18]], '#6dff8a', 2);
      this.clearGlow();
      c.globalAlpha = .25; this.poly([[x + w / 2 - 30, y + h + 60], [x + w / 2 + 30, y + h + 60], [x + w, y + h], [x, y + h]], '#55ff8a'); c.globalAlpha = 1;
    }
    c.restore();
  }
  background(stage, time, menu) {
    const c = this.ctx;
    const bg = c.createRadialGradient(menu ? 920 : 640, 360, 30, 640, 400, 820);
    bg.addColorStop(0, stage === 'dojo' ? '#1a2016' : '#0b2415'); bg.addColorStop(.5, '#04100a'); bg.addColorStop(1, '#010604');
    c.fillStyle = bg; c.fillRect(0, 0, 1280, 720);
    // Each stream has its own deterministic length, speed, and brightness.
    c.font = '12px Consolas, monospace';
    for (let col = 0; col < 63; col++) {
      const seed = noise(col + 4), x = col * 21 + 4;
      const top = ((time * (26 + seed * 40) + seed * 760) % 780) - 180;
      for (let row = 0; row < 15; row++) {
        const y = top + row * 17;
        if (y > 495) continue;
        c.fillStyle = row === 14 ? `rgba(220,255,228,${menu && x < 570 ? .06 : .32})` : `rgba(80,255,120,${(row / 15) * (menu && x < 570 ? .045 : .17)})`;
        c.fillText(glyph(col * 53 + row + Math.floor(time * 2)), x, y);
      }
    }
    if (stage === 'construct') this.construct(time, menu);
    if (stage === 'terminal') this.terminal(time);
    if (stage === 'dojo') this.dojo(time);
    // Two works per arena, inside the width a portrait phone can see (280-1000).
    const hung = { construct: [['vitruvian', 'holo'], ['fifth', 'holo']], terminal: [['scream', 'poster'], ['starry', 'poster']], dojo: [['wave', 'scroll'], ['hands', 'scroll']] }[stage];
    const spots = stage === 'terminal' ? [[292, 236, 128, 128], [860, 236, 128, 128]] : stage === 'dojo' ? [[322, 200, 180, 120], [778, 200, 180, 120]] : [[300, 205, 170, 124], [810, 205, 170, 124]];
    if (hung && !(menu && stage === 'construct')) hung.forEach(([id, style], i) => this.artFrame(id, ...spots[i], style, time));
    // Perspective ground and its submerged second horizon.
    const floor = c.createLinearGradient(0, 475, 0, 720);
    floor.addColorStop(0, '#0a2013'); floor.addColorStop(.18, '#05130b'); floor.addColorStop(1, '#010803');
    c.fillStyle = floor; c.fillRect(0, 475, 1280, 245);
    for (let i = -14; i <= 14; i++) this.line([[640 + i * 24, 475], [640 + i * 120, 720]], '#173d22');
    for (let i = 0; i < 12; i++) { const y = 477 + Math.pow(i / 11, 2.5) * 243; this.line([[0, y], [1280, y]], i % 3 === 0 ? '#1f4a2a' : '#12321b'); }
    this.line([[0, 572], [1280, 572]], '#3d7a4a');
    this.line([[0, 576], [1280, 576]], '#122c18', 3);
    c.fillStyle = '#48a35c'; for (let i = 0; i < 8; i++) c.fillRect(90 + i * 150, 670, 56, 2);
    this.text('BEAT AI WITH YOUR NATURAL INTELLIGENCE.', 42, 644, 12, '#7fa889');
    this.text('ANEMOIA / HUMAN.EXE', 1000, 644, 12, '#7fa889');
    c.fillStyle = '#020a05'; c.fillRect(0, 692, 1280, 28);
    this.line([[0, 691], [1280, 691]], '#1f4329');
  }
  construct(t, menu) {
    const c = this.ctx;
    // Suspended computational monolith. Faces carry actual vector circuitry.
    const cx = menu ? 891 : 640, y = 198 + Math.sin(t * .4) * 6;
    c.save(); c.globalAlpha = .8;
    c.strokeStyle = '#185131'; c.lineWidth = 1;
    for (let i = 0; i < 3; i++) { c.beginPath(); c.ellipse(cx, y + 114, 211 + i * 28, 75 + i * 13, -.12, 0, TAU); c.stroke(); }
    this.line([[cx, 60], [cx, 474]], '#28683d');
    this.poly([[cx, y - 81], [cx + 124, y - 14], [cx, y + 63], [cx - 124, y - 14]], '#081b10', '#3b7c4c');
    this.poly([[cx - 124, y - 14], [cx, y + 63], [cx, y + 265], [cx - 124, y + 185]], '#04120a', '#2a5c39');
    this.poly([[cx, y + 63], [cx + 124, y - 14], [cx + 124, y + 185], [cx, y + 265]], '#0b1f11', '#317148');
    for (let i = 0; i < 11; i++) {
      const x = cx + i * 10 + 6;
      this.line([[x, y + 66 - i * 6.2], [x, y + 240 - i * 6.2]], `rgba(85,210,110,${.09 + noise(i) * .15})`);
      c.fillStyle = '#5ae07a'; c.globalAlpha = .12 + noise(i + Math.floor(t)) * .28;
      c.fillRect(x, y + 93 + noise(i + 19) * 87, 3, 15 + noise(i) * 45);
    }
    c.globalAlpha = .6; if (menu) this.text('[  ORIGINAL THOUGHT: NULL  ]', cx - 97, y - 104, 10, '#6a9b76');
    this.text('01', cx - 100, y + 149, 48, '#22472d');
    c.restore();
    for (const [x, h, w] of [[80, 210, 68], [221, 116, 42], [1040, 198, 72], [1160, 286, 41]]) {
      this.poly([[x, 475], [x, 475 - h], [x + w, 466 - h], [x + w, 475]], '#06130b', '#15321d');
      this.line([[x + 4, 464], [x + 4, 492 - h]], '#316a40', 2);
      for (let j = 0; j < 7; j++) this.text(j % 2 ? '010101' : 'NUL / /', x + 12, 468 - h + j * 22, 8, '#244f31');
    }
  }
  terminal(t) {
    const c = this.ctx;
    c.fillStyle = '#0d1911'; c.fillRect(0, 172, 1280, 290);
    for (let y = 179; y < 455; y += 35) this.line([[0, y], [1280, y]], '#20362a');
    for (let x = 0; x < 1280; x += 80) this.line([[x, 174], [x, 452]], '#172c1f');
    c.fillStyle = '#000704'; c.fillRect(242, 219, 796, 240);
    for (let x = 260; x < 1040; x += 195) { c.fillStyle = '#0d2718'; c.fillRect(x, 250, 155, 113); this.line([[x, 382], [x + 155, 382]], '#3d7248'); }
    for (let x of [111, 1090]) { this.poly([[x, 130], [x + 43, 130], [x + 51, 475], [x - 5, 475]], '#08170d', '#26442f'); this.line([[x + 7, 144], [x + 7, 450]], '#407153', 3); }
    c.fillStyle = '#67be7a'; c.fillRect(180, 148, 325, 5); c.fillRect(810, 148, 291, 5);
    // Destination board hangs low over the tracks, clear of the HUD clock.
    this.line([[540, 219], [540, 262]], '#3d6d4a', 2); this.line([[740, 219], [740, 262]], '#3d6d4a', 2);
    c.fillStyle = '#06110a'; c.fillRect(505, 262, 270, 58); c.strokeStyle = '#3d6d4a'; c.strokeRect(505, 262, 270, 58);
    this.text('404 / NO DESTINATION', 530, 290, 17, '#9ad8a6'); this.text(Math.floor(t) % 6 === 0 ? 'WAKE UP.' : 'PLEASE REMAIN HUMAN.', 530, 308, 10, '#55865f');
    this.text('KEEP A LITTLE WONDER', 830, 430, 16, '#98b9a0');
    // The way out: a payphone on the platform wall, ringing now and then.
    const ring = Math.floor(t * 1.3) % 5 === 0;
    this.poly([[1168, 300], [1208, 300], [1208, 372], [1168, 372]], '#0b1a10', ring ? '#9dffb0' : '#3d6d4a', ring ? 2 : 1);
    this.poly([[1176, 312], [1200, 312], [1200, 330], [1176, 330]], '#122a19', '#4f8a5d');
    this.line([[1172, 338], [1172, 362], [1180, 364]], '#6fa87c', 3);
    this.line([[1188, 372], [1188, 456]], '#26442f', 4);
    if (ring) this.text('RING', 1172, 292, 10, '#9dffb0');
    this.line([[0, 456], [1280, 456]], '#6fbb80', 5);
    for (let x = 0; x < 1280; x += 28) this.line([[x, 464], [x + 13, 470]], '#4a8558', 3);
  }
  dojo(t) {
    const c = this.ctx;
    // A training program: paper screens with the code visible through them.
    c.fillStyle = '#1b1712'; c.fillRect(0, 110, 1280, 365);
    for (let x = 40; x < 1280; x += 200) {
      c.fillStyle = '#2a261c'; c.fillRect(x, 140, 180, 322);
      for (let gx = 0; gx < 4; gx++) for (let gy = 0; gy < 6; gy++) {
        c.fillStyle = `rgba(214,222,190,${.07 + noise(x + gx * 7 + gy) * .05})`; c.fillRect(x + 8 + gx * 43, 148 + gy * 52, 38, 47);
      }
      c.globalAlpha = .22; for (let k = 0; k < 5; k++) this.text(glyph(x + k + Math.floor(t * 2)), x + 20 + noise(x + k) * 140, 170 + ((t * 30 + k * 60 + x) % 280), 14, '#6dff8a');
      c.globalAlpha = 1;
      c.strokeStyle = '#4a3b27'; c.lineWidth = 4; c.strokeRect(x, 140, 180, 322);
    }
    c.fillStyle = '#3a2c1c'; c.fillRect(0, 110, 1280, 26); c.fillRect(0, 458, 1280, 17);
    // Hanging scroll and the one rule of the program.
    c.fillStyle = '#d9d3bb'; c.fillRect(592, 150, 96, 250); c.strokeStyle = '#5a4630'; c.strokeRect(592, 150, 96, 250);
    c.fillStyle = '#4a3b27'; c.fillRect(584, 144, 112, 8); c.fillRect(584, 398, 112, 8);
    c.fillStyle = '#1a1712'; c.font = 'bold 44px serif'; c.textAlign = 'center';
    c.fillText('覚', 640, 222); c.fillText('醒', 640, 282);
    c.font = '11px Consolas, monospace'; c.fillStyle = '#7a3a5f'; c.fillText('AWAKEN', 640, 372); c.textAlign = 'left';
    // Bonsai on a low stand.
    c.fillStyle = '#3a2c1c'; c.fillRect(912, 410, 120, 12); c.fillRect(922, 422, 8, 40); c.fillRect(1014, 422, 8, 40);
    this.poly([[948, 410], [996, 410], [990, 392], [954, 392]], '#4f3b2a');
    this.line([[972, 392], [966, 360], [980, 336], [972, 314]], '#5a4228', 5);
    for (const [bx, by, r] of [[950, 344, 22], [996, 330, 24], [970, 306, 20]]) { c.fillStyle = '#23462b'; c.beginPath(); c.ellipse(bx, by, r, r * .55, 0, 0, TAU); c.fill(); }
  }
  // `hl` is the highlight line colour down the limb.
  limb(a, b, width, fill, edge, hl) {
    const dx = b[0] - a[0], dy = b[1] - a[1], len = Math.hypot(dx, dy) || 1;
    const nx = -dy / len, ny = dx / len;
    this.poly([[a[0] + nx * width, a[1] + ny * width], [b[0] + nx * width * .65, b[1] + ny * width * .65], [b[0] - nx * width * .65, b[1] - ny * width * .65], [a[0] - nx * width, a[1] - ny * width]], fill, edge, 1.2);
    if (hl) this.line([[a[0] + nx * width * .65, a[1] + ny * width * .65], [b[0] + nx * width * .42, b[1] + ny * width * .42]], hl, 1.5);
  }
  fist(hand, skin, edge) {
    this.poly([[hand[0] - 9, hand[1] - 10], [hand[0] + 11, hand[1] - 8], [hand[0] + 15, hand[1] + 6], [hand[0] - 7, hand[1] + 9]], skin, edge);
    this.line([[hand[0] + 2, hand[1] - 8], [hand[0] + 4, hand[1] + 7]], edge, 1);
  }
  shoe(foot, fill, edge, shine) {
    this.poly([[foot[0] - 12, foot[1] - 17], [foot[0] + 11, foot[1] - 12], [foot[0] + 32, foot[1] + 2], [foot[0] - 14, foot[1] + 2]], fill, edge);
    this.line([[foot[0] - 10, foot[1] + 3], [foot[0] + 32, foot[1] + 3]], shine, 2);
  }
  fighter(f, t, { scale = 1, reflection = false, victory = false, ghost = false } = {}) {
    const c = this.ctx, machine = f.kind === 'machine';
    const accent = machine ? MINT : PILL;
    const bob = Math.sin(t * (machine ? 2 : 4)) * (machine ? 1 : 2.5);
    const dodge = f.dodge ? Math.sin(Math.min(1, f.dodge.time / DODGE.duration) * Math.PI) : 0;
    const crouch = dodge * 85, hurt = f.stun > 0 && f.action?.type !== 'power';
    const a = f.action, p = a ? Math.min(1, a.time / a.move.duration) : 0;
    const strike = a ? Math.sin(Math.min(1, a.time / (a.move.startup + a.move.active)) * Math.PI * .5) * Math.max(0, 1 - Math.max(0, p - .7) / .3) : 0;
    const walk = f.moving ? Math.sin(t * 13) * 21 : 0;
    // Heavies are kicks for both of them; Neo's air strike is a flying kick.
    const kick = a && (a.type === 'heavy' || a.type === 'air');
    const power = a?.type === 'power', lift = power ? Math.min(1, a.time / .5) : 0;
    c.save(); c.translate(f.x, WORLD.floor - f.y); c.scale(f.facing * scale, (reflection ? -scale * .36 : scale));
    if (reflection) c.globalAlpha *= .065;
    if (!machine && !reflection && !ghost) this.codeAura(t, power ? 1 : a ? Math.sin(p * Math.PI) : .06, accent);
    let lean = dodge ? -128 * dodge : hurt ? -15 : a?.type === 'light' && !kick ? strike * 13 : kick ? -strike * 16 : a?.type === 'heavy' ? -strike * 12 : 0;
    const hip = [-8, -91 + crouch * .48], shoulder = [lean + 2, -179 + bob + crouch];
    let rearKnee = [-36 - walk, -50], rearFoot = [-60 - walk, -6];
    let frontKnee = [30 + walk, -52], frontFoot = [48 + walk, -5];
    if (dodge) { rearKnee = [-43, -44]; rearFoot = [-72, -6]; frontKnee = [35, -45]; frontFoot = [69, -5]; }
    if (f.y > 5) { rearKnee = [-46, -82]; rearFoot = [-66, -53]; frontKnee = [37, -62]; frontFoot = [16, -24]; }
    if (kick) {
      const snap = a.type === 'light', top = snap ? -96 : -150;
      frontKnee = [mix(30, snap ? 60 : 57, strike), mix(-52, snap ? -84 : -116, strike)];
      frontFoot = [mix(48, snap ? 138 : 146, strike), mix(-5, top, strike)];
    }
    if (victory) shoulder[0] -= 8;
    let rearElbow = [-35 + lean, -145 + crouch], rearHand = [0 + lean, -146 + crouch];
    let frontElbow = [37 + lean, -141 + crouch], frontHand = [54 + lean, -172 + crouch];
    if (f.block) { frontElbow = [40, -145]; frontHand = [38, -211]; rearElbow = [12, -149]; rearHand = [48, -180]; }
    if (hurt) { frontElbow = [27, -144]; frontHand = [8, -123]; rearHand = [-43, -176]; }
    if (a?.type === 'light' && !kick) { frontElbow = [mix(37, 70, strike), -170]; frontHand = [mix(54, 135, strike), mix(-172, -173 + (a.stance === 'low' ? 50 : 0), strike)]; }
    if (kick) { frontElbow = [30 + lean, -160]; frontHand = [40 + lean, -196]; rearElbow = [-40 + lean, -150]; rearHand = [-62 + lean, -128]; }
    if (a?.type === 'special' || a?.type === 'super') { frontElbow = [mix(37, 60, strike), -163]; frontHand = [mix(54, 108, strike), -170]; rearHand = [mix(0, 86, strike), -155]; rearElbow = [mix(-35, 21, strike), -139]; }
    // Power: one palm out toward the machine, the other raised. The pose from the rooftop.
    if (dodge) { rearElbow = [-67 * dodge, -91]; rearHand = [-98 * dodge, -59]; frontElbow = [22 - dodge * 80, -83]; frontHand = [56 - dodge * 95, -60]; }
    if (power) { frontElbow = [mix(37, 70, lift), mix(-141, -168, lift)]; frontHand = [mix(54, 118, lift), mix(-172, -178, lift)]; rearElbow = [mix(-35, -52, lift), mix(-145, -196, lift)]; rearHand = [mix(0, -40, lift), mix(-146, -246, lift)]; }
    if (victory) { frontElbow = [33, -199]; frontHand = [16, -265]; }
    // Palette: Neo is black leather on black; the Agent is a charcoal suit and white shirt.
    const skin = machine ? '#b58e78' : '#c8977b', skinEdge = machine ? '#5e4536' : '#6d4b3b';
    const cloth = machine ? '#1b201e' : '#0a0c0b', clothDark = machine ? '#121615' : '#050706';
    const edge = machine ? '#56605b' : '#39423f', hl = machine ? '#39413e' : '#1f2523';
    // Rear limbs, then coat or jacket, then the near limbs produce a readable silhouette.
    this.limb([shoulder[0] - 16, shoulder[1] + 10], rearElbow, 14, clothDark, edge, hl);
    this.limb(rearElbow, rearHand, 11, clothDark, edge, hl);
    this.fist(rearHand, skin, skinEdge);
    this.limb(hip, rearKnee, 16, clothDark, edge, hl);
    this.limb(rearKnee, rearFoot, 13, clothDark, edge, hl);
    this.shoe(rearFoot, '#050605', '#2d3431', '#2d3431');
    if (!machine) {
      // The long coat trails the motion and flares open in bullet time.
      const sway = Math.sin(t * 3) * 5 - f.moving * 14 - dodge * 40 - (kick ? strike * 18 : 0);
      const hem = f.y > 5 ? -40 : -12;
      this.poly([[shoulder[0] - 20, shoulder[1] + 2], [shoulder[0] + 18, shoulder[1] + 6], [22, -100 + crouch * .5], [34 + sway * .2, -56 + crouch * .3], [20 + sway * .5, hem], [-14 + sway, hem + 4], [-46 + sway * 1.4, hem - 4], [-62 + sway * 1.7, hem - 20], [-38, -110 + crouch * .5]], '#060807', '#39423f', 1.4);
      c.save(); c.globalAlpha *= .5; this.line([[-38, -112 + crouch * .5], [-62 + sway * 1.7, hem - 20]], accent, 1.5); c.restore();
      this.line([[-18, -120 + crouch * .5], [-26 + sway, hem]], '#1a201e', 2);
    }
    this.limb(hip, frontKnee, 16, cloth, edge, hl);
    this.limb(frontKnee, frontFoot, 13, cloth, edge, hl);
    this.shoe(frontFoot, '#070807', edge, machine ? '#6f7a75' : '#48524e');
    if (machine) {
      // Jacket, white shirt, black tie.
      this.poly([[shoulder[0] - 26, shoulder[1] - 2], [shoulder[0] + 25, shoulder[1]], [26, -132 + crouch * .5], [18, -88 + crouch * .4], [-20, -86 + crouch * .4], [-32, -146 + crouch]], cloth, edge, 1.5);
      this.poly([[shoulder[0] - 6, shoulder[1] + 1], [shoulder[0] + 14, shoulder[1] + 2], [6, -136 + crouch * .8]], '#e6ebe8', '#aab3af');
      this.poly([[shoulder[0] + 2, shoulder[1] + 4], [shoulder[0] + 8, shoulder[1] + 4], [7, -130 + crouch * .7], [3, -123 + crouch * .7], [0, -130 + crouch * .7]], '#040605');
      this.line([[shoulder[0] - 6, shoulder[1] + 1], [2, -128 + crouch * .7], [10, -104 + crouch * .4]], '#3a4340', 2);
      this.line([[shoulder[0] + 14, shoulder[1] + 2], [8, -134 + crouch * .8]], '#3a4340', 2);
      c.fillStyle = '#0a0d0c'; for (let j = 0; j < 2; j++) { c.beginPath(); c.arc(9, -118 + j * 12 + crouch * .5, 1.8, 0, TAU); c.fill(); }
    } else {
      // Black shirt under the coat's open front and lapels.
      this.poly([[shoulder[0] - 22, shoulder[1] - 4], [shoulder[0] + 24, shoulder[1]], [25, -130 + crouch * .5], [10, -98 + crouch * .5], [-22, -106 + crouch * .5], [-30, -149 + crouch]], '#0c0f0e', edge, 1.5);
      this.poly([[shoulder[0] - 4, shoulder[1] + 1], [shoulder[0] + 16, shoulder[1] + 2], [9, -118 + crouch * .5], [-4, -126 + crouch * .5]], '#141817', '#2a3230');
      this.line([[shoulder[0] + 18, shoulder[1] + 4], [12, -140 + crouch], [22, -110 + crouch * .5]], '#56605c', 2);
      this.line([[shoulder[0] - 12, shoulder[1] + 4], [-10, -138 + crouch], [-18, -112 + crouch * .5]], '#434c49', 2);
    }
    // Neck and head.
    const hx = shoulder[0] + 4, hy = shoulder[1] - 28;
    c.save(); c.translate(hx, hy); c.rotate(-dodge * .8); c.translate(-hx, -hy);
    this.limb([hx - 3, hy + 19], [hx - 4, hy + 29], 8, skin, skinEdge);
    if (machine) {
      this.poly([[hx - 18, hy - 16], [hx + 12, hy - 19], [hx + 22, hy - 6], [hx + 22, hy + 8], [hx + 24, hy + 13], [hx + 18, hy + 16], [hx + 16, hy + 25], [hx - 4, hy + 27], [hx - 18, hy + 12]], skin, skinEdge);
      this.poly([[hx - 20, hy - 2], [hx - 21, hy - 16], [hx - 10, hy - 25], [hx + 8, hy - 26], [hx + 21, hy - 20], [hx + 22, hy - 13], [hx + 6, hy - 15], [hx - 6, hy - 12], [hx - 12, hy]], '#2a211b', '#4a3a2e');
      this.line([[hx - 16, hy - 20], [hx + 14, hy - 22]], '#4a3a2e', 1);
      // Rectangular shades with the system's glint.
      this.poly([[hx + 2, hy - 7], [hx + 23, hy - 7], [hx + 22, hy + 2], [hx + 3, hy + 2]], '#010201', '#2d3431');
      this.line([[hx + 2, hy - 5], [hx - 7, hy - 3]], '#1c211f', 2);
      this.glow(accent, 10); this.line([[hx + 8, hy - 5], [hx + 18, hy - 5]], accent, 1.5); this.clearGlow();
      this.line([[hx + 8, hy + 18], [hx + 17, hy + 18]], '#6e5040', 1.5);
      // Earpiece and its coiled wire down into the collar.
      c.fillStyle = '#e3e8e5'; c.beginPath(); c.arc(hx - 7, hy + 2, 2.5, 0, TAU); c.fill();
      c.beginPath(); c.moveTo(hx - 8, hy + 4);
      for (let k = 1; k <= 12; k++) c.lineTo(hx - 9 + Math.sin(k * 2.2) * 2, hy + 4 + k * 2.3);
      c.strokeStyle = '#d6dcd9'; c.lineWidth = 1.1; c.stroke();
    } else {
      this.poly([[hx - 16, hy - 14], [hx + 13, hy - 18], [hx + 22, hy - 5], [hx + 21, hy + 6], [hx + 25, hy + 11], [hx + 17, hy + 14], [hx + 13, hy + 25], [hx - 2, hy + 27], [hx - 19, hy + 8]], skin, skinEdge);
      // Slicked-back black hair.
      this.poly([[hx - 22, hy + 6], [hx - 25, hy - 12], [hx - 15, hy - 27], [hx + 4, hy - 31], [hx + 19, hy - 25], [hx + 23, hy - 15], [hx + 10, hy - 17], [hx - 2, hy - 14], [hx - 8, hy + 4], [hx - 16, hy + 12]], '#040504', '#262d2a', 1.2);
      this.line([[hx - 18, hy - 20], [hx + 4, hy - 27], [hx + 18, hy - 23]], '#2f3834', 1.5);
      // Small oval shades, no frame to speak of.
      c.fillStyle = '#010201'; c.beginPath(); c.ellipse(hx + 15, hy - 2, 7, 4.5, 0, 0, TAU); c.fill();
      c.strokeStyle = '#3b4441'; c.lineWidth = 1; c.stroke();
      this.line([[hx + 8, hy - 3], [hx - 6, hy - 2]], '#2a3230', 1.5);
      this.glow(accent, 8); this.line([[hx + 12, hy - 4], [hx + 17, hy - 4]], accent, 1.2); this.clearGlow();
      this.line([[hx + 10, hy + 19], [hx + 18, hy + 18]], '#7a5646', 1.5);
    }
    c.restore();
    this.limb([shoulder[0] + 18, shoulder[1] + 8], frontElbow, machine ? 13 : 15, cloth, edge, hl);
    this.limb(frontElbow, frontHand, machine ? 10 : 12, cloth, edge, hl);
    if (machine) this.line([[frontHand[0] - 11, frontHand[1] - 9], [frontHand[0] - 9, frontHand[1] + 8]], '#e6ebe8', 3);
    this.fist(frontHand, skin, skinEdge);
    // Attack effects are part of the live animation.
    if (a && a.time >= a.move.startup * .5 && !reflection && !ghost) {
      if (!machine) { if (!power) this.martialAttack(a, p, strike, kick ? frontFoot : frontHand); }
      else if (a.type === 'special') this.sidearm(a, p, strike, frontHand);
      else {
        c.save(); c.globalAlpha = Math.sin(p * Math.PI) * .8; this.glow(accent, 14);
        if (a.type === 'light') this.line([[frontHand[0] - 50, frontHand[1]], [frontHand[0] - 6, frontHand[1]]], accent, 2);
        if (a.type === 'heavy') {
          this.line([[42, -226], [165 * strike, -188], [184 * strike, -105], [105, -61]], accent, 3);
          this.line([[51, -213], [153 * strike, -180], [171 * strike, -110]], '#d9ffe4', 1);
        }
        if (a.type === 'super') {
          const length = 510;
          c.font = '15px Consolas, monospace';
          for (let j = 0; j < 9; j++) for (let k = 0; k < 5; k++) {
            c.fillStyle = k ? accent : '#e8fff0'; c.fillText(glyph(j * 5 + k + Math.floor(t * 14)), 103 + j * length / 9, -230 + k * 22 + Math.sin(j + t * 6) * 10);
          }
          this.line([[91, -163], [124 + length * strike, -163]], '#e8fff0', 9);
        }
        this.clearGlow(); c.restore();
      }
    }
    if (f.block && !reflection) { c.save(); c.globalAlpha = .55; this.glow(accent, 10); this.line([[67, -225], [86, -178], [70, -106]], accent, 2); this.clearGlow(); c.restore(); }
    if (f.hitFlash > 0 && !reflection) {
      c.globalAlpha = f.hitFlash * 2; this.poly([[-33, -200], [30, -193], [47, -90], [-28, -81]], machine ? '#baffcc' : '#fff0f8');
      // Hit an Agent and the code shows through the suit.
      if (machine) for (let k = 0; k < 8; k++) this.text(glyph(k + Math.floor(t * 30)), -28 + noise(k) * 60, -190 + k * 13, 14, '#0f4a22');
    }
    c.restore();
  }
  event(event) {
    if (event.type === 'hit' || event.type === 'block') {
      const hit = event.type === 'hit', human = event.kind === 'human', big = event.move === 'super' || event.move === 'power';
      const amount = hit ? big ? 58 : 23 : 12;
      const color = human ? (event.power ? POWERS[event.power].color : PILL) : MINT;
      for (let i = 0; i < amount; i++) {
        const angle = Math.random() * TAU, speed = 65 + Math.random() * (hit ? 490 : 235);
        this.particles.push({ x: event.x, y: event.y, vx: Math.cos(angle) * speed, vy: Math.sin(angle) * speed, ttl: .4 + Math.random() * .5, max: .9,
          color: human ? (i % 3 === 0 ? color : SHARDS[i % 5]) : i % 3 ? MINT : '#d9ffe9', glyph: human ? i % 4 === 0 : i % 2 === 0, seed: i });
      }
      if (hit) { this.shake = big ? 14 : event.move === 'heavy' ? 6 : 3; this.flash = .06; }
      if (hit && event.move !== 'power') this.labels.push({ x: event.x, y: event.y - 84, text: event.varied && human ? 'UNPREDICTABLE +' : `−${event.damage}`, ttl: .9, color });
      if (hit && human) this.rings.push({ x: event.x, y: WORLD.floor + 4, ttl: .6, color });
    }
    if (event.type === 'super') { this.superFlash = 1; this.superKind = event.kind; this.shake = 7; }
    if (event.type === 'power') this.powerFx = { id: event.power, t: 0, dur: event.finishing ? 3.6 : 1.7, finishing: event.finishing };
    if (event.type === 'evade') { this.evadeFlash = .9; this.evadeY = event.y; }
    if (event.type === 'finisher') { this.koFx = { t: 0, x: event.x }; this.flash = .25; this.shake = 18; }
    if (event.type === 'round' || event.type === 'fight') { this.koFx = null; this.powerFx = null; }
  }
  // --- The six powers. All drawn in a frame where x runs from Neo (0) toward the Agent (D). ---
  env(k) { const s = (a, b, v) => { const x = Math.max(0, Math.min(1, (v - a) / (b - a))); return x * x * (3 - 2 * x); }; return s(0, .1, k) * (1 - s(.86, 1, k)); }
  wave(k, D, t) {
    const c = this.ctx, clamp1 = v => Math.max(0, Math.min(1, v)), ease = v => 1 - Math.pow(1 - v, 3);
    const rise = ease(clamp1(k * 1.7)), travel = ease(clamp1((k - .12) / .55));
    this.poly([[D * .5 - 90, 520], [D * .5, 450], [D * .5 + 90, 520]], '#27406e'); this.poly([[D * .5 - 22, 468], [D * .5, 450], [D * .5 + 22, 468], [D * .5 + 6, 474], [D * .5 - 8, 470]], '#f4f6ff');
    const cx = mix(-300, D + 30, travel), H = 150 + 340 * rise, base = 620;
    c.beginPath(); c.moveTo(cx - 1000, base);
    c.bezierCurveTo(cx - 520, base - H * .22, cx - 230, base - H * .96, cx - 40, base - H);
    c.bezierCurveTo(cx + 90, base - H * 1.02, cx + 180, base - H * .84, cx + 158, base - H * .6);
    c.bezierCurveTo(cx + 128, base - H * .44, cx + 62, base - H * .54, cx + 74, base - H * .7);
    c.bezierCurveTo(cx + 24, base - H * .55, cx + 12, base - H * .2, cx + 70, base);
    c.closePath();
    const g = c.createLinearGradient(0, base - H, 0, base);
    g.addColorStop(0, '#eaf2ff'); g.addColorStop(.16, '#4f8ccc'); g.addColorStop(.55, '#1c3f7a'); g.addColorStop(1, '#0c1f40');
    c.fillStyle = g; c.fill(); c.strokeStyle = '#08162e'; c.lineWidth = 3; c.stroke();
    for (let j = 1; j < 7; j++) { c.beginPath(); c.moveTo(cx - 900 + j * 30, base); c.bezierCurveTo(cx - 500, base - H * .2 + j * 26, cx - 230 + j * 10, base - H * .9 + j * 30, cx - 50, base - H + j * 30); c.strokeStyle = 'rgba(225,238,255,.45)'; c.lineWidth = 2; c.stroke(); }
    // Claws of foam along the curl.
    const ox = cx + 96, oy = base - H * .68, r = H * .2;
    for (let i = 0; i < 16; i++) {
      const ang = -2.9 + i * .25, fx = ox + Math.cos(ang) * r, fy = oy + Math.sin(ang) * r;
      c.fillStyle = '#f4f8ff'; c.beginPath(); c.arc(fx, fy, 7 + noise(i) * 5, 0, TAU); c.fill();
      this.line([[fx, fy], [fx + Math.cos(ang + 1.2) * 14, fy + Math.sin(ang + 1.2) * 14]], '#f4f8ff', 3);
    }
    c.fillStyle = '#f4f8ff';
    for (let i = 0; i < 46; i++) { c.beginPath(); c.arc(cx + 150 + noise(i) * 280 * travel, base - H * .65 + noise(i + 5) * H * .7 + k * 180 * noise(i + 9), 2 + noise(i + 2) * 4, 0, TAU); c.fill(); }
  }
  starry(k, D, t) {
    const c = this.ctx, collapse = Math.max(0, Math.min(1, (k - .45) / .35));
    // Cypress, a black flame beside Neo.
    c.beginPath(); c.moveTo(-150, 575);
    for (let y = 0; y <= 470; y += 20) c.lineTo(-150 + Math.sin(y * .05 + t * 2) * 10 - (1 - y / 470) * 40 + y * .06, 575 - y);
    for (let y = 470; y >= 0; y -= 20) c.lineTo(-110 + Math.sin(y * .05 + t * 2 + 1) * 10 + (1 - y / 470) * 40 - y * .06, 575 - y);
    c.fillStyle = '#0a1a10'; c.fill();
    // The great swirl up in the sky, always turning.
    for (let i = 0; i < 70; i++) {
      const a = i * .36 + t * 1.4, r = 10 + i * 1.8, x = D * .42 + Math.cos(a) * r * 1.4, y = 170 + Math.sin(a) * r * .7;
      this.line([[x, y], [D * .42 + Math.cos(a + .3) * r * 1.4, 170 + Math.sin(a + .3) * r * .7]], ['#e9f0ff', '#8fb8e8', '#3f6fb5'][i % 3], 5);
    }
    // Stars with their halos.
    for (let i = 0; i < 9; i++) {
      const sx = -200 + noise(i + 3) * (D + 500), sy = 70 + noise(i + 11) * 170;
      for (let h = 3; h >= 1; h--) { c.fillStyle = h === 1 ? '#fff6b0' : `rgba(245,213,71,${.18 * (4 - h)})`; c.beginPath(); c.arc(sx, sy, h * 9 + Math.sin(t * 3 + i) * 2, 0, TAU); c.fill(); }
    }
    c.fillStyle = '#ffd84a'; c.beginPath(); c.arc(D + 160, 100, 36, 0, TAU); c.fill();
    c.fillStyle = '#10204d'; c.beginPath(); c.arc(D + 176, 92, 32, 0, TAU); c.fill();
    // The vortex that swallows the Agent.
    for (let i = 0; i < 150; i++) {
      const a = i * .31 + t * 2.4 + k * 5, r = (16 + i * 1.8) * (1 - .6 * collapse);
      const x = D + Math.cos(a) * r * 1.2, y = 420 + Math.sin(a) * r * .85;
      this.line([[x, y], [D + Math.cos(a + .24) * r * 1.2, 420 + Math.sin(a + .24) * r * .85]], ['#f5d547', '#8fb8e8', '#e9f0ff', '#3f6fb5'][i % 4], 6 - i * .025);
    }
    if (collapse > .85) { c.globalAlpha *= (1 - collapse) * 6; c.fillStyle = '#fff6b0'; c.beginPath(); c.arc(D, 420, 120 * collapse, 0, TAU); c.fill(); }
  }
  note(x, y, size, color) {
    const c = this.ctx;
    c.save(); c.translate(x, y); c.scale(size / 40, size / 40); c.fillStyle = color;
    c.beginPath(); c.ellipse(-8, 12, 12, 8, -.35, 0, TAU); c.fill();
    this.line([[3, 10], [3, -38]], color, 4); this.line([[3, -38], [20, -22], [16, -8]], color, 4);
    c.restore();
  }
  fifth(k, D, t) {
    const beats = [.06, .18, .3, .48];
    for (let j = 0; j < 5; j++) this.line([[-2000, 330 + j * 22], [3000, 330 + j * 22]], 'rgba(233,215,166,.45)', 2);
    beats.forEach((b, i) => {
      if (k < b) return;
      const long = i === 3, q = Math.min(1, (k - b) / (long ? .36 : .2));
      this.ctx.save(); this.ctx.globalAlpha *= 1 - q * .8;
      this.ring(60, 405, q * D * 1.1 + 10, q * 220 + 10, '#ffe9b8', (long ? 12 : 5) * (1 - q) + 1);
      this.ctx.restore();
      this.note(mix(60, D, 1 - Math.pow(1 - q, 2)), 405 - Math.sin(q * Math.PI) * 90, long ? 110 : 64, '#fff3d6');
    });
  }
  fifthText(k) {
    const c = this.ctx, beats = [.06, .18, .3, .48], words = ['DA', 'DA', 'DA', 'DUMMM'];
    c.save(); c.textAlign = 'center';
    beats.forEach((b, i) => { if (k < b) return; c.globalAlpha = Math.min(1, (k - b) * 12) * this.env(k); c.fillStyle = '#ffe9b8'; c.font = `${i === 3 ? 96 : 66}px Arcade, Impact, sans-serif`; c.fillText(words[i], 330 + i * 190, 672); });
    c.restore();
  }
  vitruvian(k, D, t) {
    const c = this.ctx, draw = Math.min(1, k * 2.2), ink = '#4a2e14';
    this.glow('#e0b27a', 14);
    c.beginPath(); c.arc(0, 415, 200, -Math.PI / 2, -Math.PI / 2 + TAU * draw); c.strokeStyle = ink; c.lineWidth = 4; c.stroke();
    const side = 340, sx = -side / 2, sy = 575 - side, per = side * 4 * draw;
    c.beginPath(); c.moveTo(sx, 575);
    [[sx, sy], [sx + side, sy], [sx + side, 575], [sx, 575]].reduce((left, [x, y], i, arr) => {
      if (left <= 0) return 0; const [px, py] = i ? arr[i - 1] : [sx, 575]; const len = Math.hypot(x - px, y - py), f = Math.min(1, left / len);
      c.lineTo(px + (x - px) * f, py + (y - py) * f); return left - len;
    }, per);
    c.stroke();
    // The extra arms and legs of the drawing, spread across the circle.
    c.globalAlpha *= draw;
    for (const ang of [-2.6, -.55, -2.2, -.95]) this.line([[0, 395], [Math.cos(ang) * 200, 415 + Math.sin(ang) * 200]], ink, 3);
    for (const ang of [2.0, 1.15]) this.line([[0, 480], [Math.cos(ang) * 200, 415 + Math.sin(ang) * 200]], ink, 3);
    // Mirror-writing in the margin.
    for (let r = 0; r < 6; r++) { c.beginPath(); for (let x = 0; x < 110; x += 4) c.lineTo(-360 + x, 240 + r * 22 + Math.sin(x * .5 + r) * 4); c.strokeStyle = 'rgba(74,46,20,.7)'; c.lineWidth = 1.5; c.stroke(); }
    const q = Math.max(0, Math.min(1, (k - .42) / .25));
    if (q > 0) {
      for (let j = -2; j <= 2; j++) this.line([[70, 405 + j * 7], [70 + (D - 70) * q, 405 + j * 7 + Math.sin(j + t * 20) * 3]], j ? ink : '#ffe2b0', j ? 3 : 7);
      if (q >= 1) for (let j = 0; j < 10; j++) { c.fillStyle = ink; c.beginPath(); c.arc(D + (noise(j) - .5) * 120, 405 + (noise(j + 4) - .5) * 160, 6 + noise(j + 8) * 14, 0, TAU); c.fill(); }
    }
    this.clearGlow();
  }
  screamSky(k, nx, ax, t) {
    const c = this.ctx, colors = ['#e8562a', '#f39a3a', '#f5c14d', '#c8372a', '#e8562a', '#f39a3a', '#f5c14d', '#27456b', '#3e6d8e', '#1b2d45', '#27456b', '#3e6d8e'];
    colors.forEach((col, j) => {
      c.beginPath();
      for (let x = -20; x <= 1300; x += 20) c.lineTo(x, 60 + j * 36 + Math.sin(x * .008 + t * 2.2 + j * .6) * (12 + k * 26));
      c.strokeStyle = col; c.lineWidth = 20; c.globalAlpha = .55 * this.env(k); c.stroke();
    });
    c.globalAlpha = this.env(k);
    this.line([[-40, 720], [560, 420]], '#6b3f23', 10); this.line([[-40, 690], [520, 410]], '#8a5530', 4);
  }
  scream(k, D, t) {
    const c = this.ctx;
    for (let i = 0; i < 5; i++) {
      const rr = ((k * 1.6 + i / 5) % 1), R = rr * D * 1.25 + 30;
      c.beginPath();
      for (let a = 0; a <= TAU + .01; a += .15) { const w = R + Math.sin(a * 8 + t * 7) * 8; c.lineTo(Math.cos(a) * w, 380 + Math.sin(a) * w * .8); }
      c.strokeStyle = '#ffd2a0'; c.lineWidth = 3; c.save(); c.globalAlpha *= 1 - rr; c.stroke(); c.restore();
    }
    // The face: hands to the cheeks, mouth open.
    c.save(); c.translate(8, 368);
    c.fillStyle = '#e6dcc0'; c.beginPath(); c.ellipse(0, 0, 34, 46, 0, 0, TAU); c.fill();
    c.fillStyle = '#2a1d14'; c.beginPath(); c.ellipse(-12, -8, 6, 9, 0, 0, TAU); c.ellipse(12, -8, 6, 9, 0, 0, TAU); c.fill();
    c.beginPath(); c.ellipse(0, 22, 8, 13 + Math.sin(t * 20) * 2, 0, 0, TAU); c.fill();
    this.line([[-34, -6], [-44, 30], [-40, 70]], '#e6dcc0', 10); this.line([[34, -6], [44, 30], [40, 70]], '#e6dcc0', 10);
    c.restore();
  }
  hand(x, y, rot, scale, halo) {
    const c = this.ctx;
    c.save(); c.translate(x, y); c.rotate(rot); c.scale(scale, scale);
    const g = c.createRadialGradient(0, -10, 10, 0, -10, 78); g.addColorStop(0, halo); g.addColorStop(1, 'rgba(0,0,0,0)');
    c.fillStyle = g; c.beginPath(); c.arc(0, -10, 78, 0, TAU); c.fill();
    c.fillStyle = '#2a1a10'; c.strokeStyle = '#2a1a10'; c.lineCap = 'round'; c.lineWidth = 13;
    c.beginPath(); c.ellipse(0, 6, 22, 26, 0, 0, TAU); c.fill();
    for (const [a, l] of [[-.42, 38], [-.14, 44], [.14, 42], [.4, 34]]) this.line([[Math.sin(a) * 14, -12], [Math.sin(a) * (14 + l), -12 - Math.cos(a) * l]], '#2a1a10', 12);
    this.line([[-18, 10], [-44, -8]], '#2a1a10', 13);
    c.restore();
  }
  hands(k, D, t) {
    const c = this.ctx, halos = ['#c4502a', '#e08a3c', '#a33a1f', '#f0d9a8'];
    for (let i = 0; i < 9; i++) {
      const ti = .06 + i * .065; if (k < ti) continue;
      const q = Math.min(1, (k - ti) / .07);
      this.hand(mix(20, D, i / 8), 300 + noise(i) * 200, (noise(i + 3) - .5) * .9, .9 + (1 - q) * .7, halos[i % 4]);
    }
    const run = Math.max(0, Math.min(1, (k - .3) / .5));
    for (let j = 0; j < 2; j++) {
      const bx = mix(-260, D + 80, 1 - Math.pow(1 - run, 2)) - j * 150, by = 560 - j * 18;
      c.save(); c.translate(bx, by);
      c.fillStyle = '#6d2716'; c.strokeStyle = '#2a120a'; c.lineWidth = 3;
      c.beginPath(); c.moveTo(-70, -30); c.bezierCurveTo(-60, -80, 10, -95, 40, -60); c.bezierCurveTo(70, -55, 80, -20, 62, -6); c.lineTo(-60, -8); c.closePath(); c.fill(); c.stroke();
      const step = Math.sin(t * 18 + j) * 10;
      for (const lx of [-50, -30, 30, 48]) this.line([[lx, -10], [lx + step * (lx > 0 ? 1 : -1), 12]], '#2a120a', 6);
      this.line([[58, -40], [72, -58]], '#e8d9b0', 4);
      c.restore();
    }
  }
  // The finished frame: everything the power draws, plus its tint over the arena.
  drawPower(match) {
    const fx = this.powerFx; if (!fx || !match) return;
    const c = this.ctx, k = Math.min(1, fx.t / fx.dur), e = this.env(k), t = this.time;
    const [neo, agent] = match.fighters, dir = agent.x >= neo.x ? 1 : -1, D = Math.max(160, Math.abs(agent.x - neo.x));
    const tint = { wave: '#0d2340', starry: '#0d1d4a', fifth: '#2a1d0e', vitruvian: '#c9a877', scream: '#3a1a10', hands: '#3a2415' }[fx.id];
    c.save(); c.globalAlpha = e * (fx.id === 'vitruvian' ? .32 : .55); c.fillStyle = tint; c.fillRect(-400, -200, 2100, 1200); c.restore();
    c.save(); c.globalAlpha = e;
    if (fx.id === 'scream') this.screamSky(k, neo.x, agent.x, t);
    c.translate(neo.x, 0); c.scale(dir, 1);
    this[fx.id](k, D, t);
    c.restore();
    if (fx.id === 'fifth') this.fifthText(k);
  }
  // Menu icons for the three power buttons, drawn into a small square canvas.
  icon(canvas, id) {
    const original = this.ctx; this.ctx = canvas.getContext('2d'); const c = this.ctx, s = canvas.width / 64;
    c.setTransform(s, 0, 0, s, 0, 0); c.clearRect(0, 0, 64, 64); c.lineCap = 'round'; c.lineJoin = 'round';
    const col = POWERS[id].color;
    if (id === 'wave') { c.beginPath(); c.moveTo(4, 54); c.bezierCurveTo(14, 44, 22, 14, 40, 12); c.bezierCurveTo(56, 12, 60, 30, 48, 34); c.bezierCurveTo(40, 36, 38, 26, 44, 24); c.strokeStyle = col; c.lineWidth = 5; c.stroke(); this.line([[4, 58], [60, 58]], col, 3); }
    if (id === 'starry') { for (let i = 0; i < 30; i++) { const a = i * .45, r = 3 + i * .9; this.line([[32 + Math.cos(a) * r, 32 + Math.sin(a) * r], [32 + Math.cos(a + .35) * r, 32 + Math.sin(a + .35) * r]], col, 3.5); } }
    if (id === 'fifth') { this.note(26, 36, 44, col); this.note(46, 30, 30, col); }
    if (id === 'vitruvian') { this.ring(32, 32, 26, 26, col, 3); c.strokeStyle = col; c.lineWidth = 3; c.strokeRect(12, 12, 40, 40); this.line([[32, 18], [32, 44]], col, 3); this.line([[12, 26], [52, 26]], col, 3); this.line([[32, 44], [20, 58]], col, 3); this.line([[32, 44], [44, 58]], col, 3); }
    if (id === 'scream') { c.fillStyle = col; c.beginPath(); c.ellipse(32, 30, 14, 19, 0, 0, TAU); c.fill(); c.fillStyle = '#1a0f0a'; c.beginPath(); c.ellipse(26, 26, 3, 5, 0, 0, TAU); c.ellipse(38, 26, 3, 5, 0, 0, TAU); c.ellipse(32, 40, 4, 6, 0, 0, TAU); c.fill(); this.line([[18, 30], [14, 56]], col, 5); this.line([[46, 30], [50, 56]], col, 5); }
    if (id === 'hands') { c.save(); c.translate(32, 38); c.fillStyle = col; c.beginPath(); c.ellipse(0, 4, 11, 13, 0, 0, TAU); c.fill(); for (const [a, l] of [[-.42, 18], [-.14, 21], [.14, 20], [.4, 16]]) this.line([[Math.sin(a) * 7, -6], [Math.sin(a) * (7 + l), -6 - Math.cos(a) * l]], col, 6); this.line([[-9, 6], [-22, -4]], col, 6); c.restore(); }
    this.ctx = original;
  }
  bootRain(t) {
    const c = this.ctx; c.fillStyle = '#000'; c.fillRect(0, 0, 1280, 720); c.font = '16px Consolas, monospace';
    for (let col = 0; col < 64; col++) {
      const seed = noise(col + 7), x = col * 20 + 3, top = ((t * (60 + seed * 90) + seed * 900) % 1000) - 240;
      for (let row = 0; row < 18; row++) {
        const y = top + row * 20; if (y < -20 || y > 740) continue;
        c.fillStyle = row === 17 ? 'rgba(230,255,236,.9)' : `rgba(60,255,110,${(row / 18) * .55})`;
        c.fillText(glyph(col * 31 + row + Math.floor(t * 8)), x, y);
      }
    }
  }
  draw(match, dt, { menu = false, boot = false, reduced = false, stage = 'construct' } = {}) {
    this.reduced = reduced; this.time += dt * (reduced ? .3 : 1);
    const c = this.ctx, t = this.time;
    // Always show the full height of the world. Portrait screens see the middle of
    // its width; very wide screens get dark margins (where the phone pad sits).
    const s = this.scaleY, spare = this.canvas.width - 1280 * s;
    const ox = spare < 0 && menu ? spare * .84 : spare / 2;
    c.setTransform(s, 0, 0, s, ox, 0);
    if (boot) { this.bootRain(t); return; }
    if (this.powerFx) { this.powerFx.t += dt; if (this.powerFx.t > this.powerFx.dur) this.powerFx = null; }
    if (this.koFx) this.koFx.t += dt;
    const zoomTarget = this.koFx && !reduced && this.koFx.t < 4 ? 1.18 : 1;
    this.zoom += (zoomTarget - this.zoom) * Math.min(1, dt * 1.6);
    c.save();
    if (this.zoom > 1.001 && this.koFx) { const fx = this.koFx.x, fy = 420; c.translate(fx, fy); c.scale(this.zoom, this.zoom); c.translate(-fx, -fy); }
    if (!reduced && this.shake > .1) c.translate((Math.random() - .5) * this.shake, (Math.random() - .5) * this.shake);
    this.shake *= .85;
    this.background(match?.stage || stage, t, menu);
    for (const ring of this.rings) {
      ring.ttl -= dt; const k = 1 - Math.max(0, ring.ttl) / .6;
      c.save(); c.globalAlpha = (1 - k) * .7; this.ring(ring.x, ring.y, 20 + k * 150, 4 + k * 24, ring.color, 2); c.restore();
    }
    this.rings = this.rings.filter(r => r.ttl > 0);
    const fighters = match?.fighters || [
      { kind: 'human', x: 845, y: 0, facing: -1, stun: 0, moving: 0, hitFlash: 0 },
      { kind: 'machine', x: 1090, y: 0, facing: -1, stun: 0, moving: 0, hitFlash: 0 },
    ];
    const scaleOf = f => menu ? (f === fighters[0] ? 1.54 : 1.12) : 1.12;
    for (const f of fighters) {
      if (f.derez >= 1) continue;
      c.save(); c.fillStyle = '#0009'; c.beginPath(); c.ellipse(f.x, WORLD.floor + 4, menu ? 105 : 76, 14, 0, 0, TAU); c.fill(); c.restore();
      this.fighter(f, t, { scale: scaleOf(f), reflection: true });
    }
    // Powers paint over the arena but behind the fighters, so both stay readable.
    this.drawPower(match);
    if (this.koFx && !reduced) {
      // Finisher: the world drains and speed lines converge on the Agent.
      const k = Math.min(1, this.koFx.t / .4);
      c.save(); c.globalAlpha = .45 * k; c.fillStyle = '#000'; c.fillRect(-400, -200, 2100, 1200); c.globalAlpha = .5 * k;
      for (let i = 0; i < 36; i++) { const a = i * TAU / 36 + t * .2, r0 = 160 + noise(i) * 60; this.line([[this.koFx.x + Math.cos(a) * r0, 420 + Math.sin(a) * r0], [this.koFx.x + Math.cos(a) * 1200, 420 + Math.sin(a) * 1200]], i % 3 ? '#1f6b35' : '#e8fff0', 2); }
      c.restore();
    }
    for (const f of [...fighters].reverse()) {
      const won = match && ['roundEnd', 'matchEnd'].includes(match.phase) && match.roundWinner === f.slot;
      const lost = match && ['roundEnd', 'matchEnd'].includes(match.phase) && match.roundWinner !== null && match.roundWinner !== f.slot && !f.derez;
      if (f.derez >= 1) continue;
      if (lost) { c.save(); c.translate(f.x, WORLD.floor); c.scale(1, .3); c.translate(-f.x, -WORLD.floor); }
      if (f.dodge && !reduced) {
        for (let j = 3; j >= 1; j--) {
          c.save(); c.globalAlpha = .08 + (3 - j) * .03; c.shadowColor = PILL; c.shadowBlur = 15;
          this.fighter({ ...f, x: f.x - f.facing * j * 16, dodge: { ...f.dodge, time: Math.max(.015, f.dodge.time - j * .035) } }, t, { scale: 1.12, ghost: true }); c.restore();
        }
      }
      if (f.kind === 'machine' && f.action?.type === 'super' && !reduced) {
        const k = Math.sin(Math.min(1, f.action.time / f.action.move.duration) * Math.PI);
        for (let j = 1; j <= 3; j++) {
          c.save(); c.globalAlpha = k * (.5 - j * .1); c.shadowColor = MINT; c.shadowBlur = 12;
          this.fighter({ ...f, x: f.x + f.facing * j * 115 * k, action: null, hitFlash: 0 }, t + j, { scale: 1.12, ghost: true }); c.restore();
        }
      }
      if (f.derez > 0) {
        // Derez: the Agent comes apart into code from the head down.
        const top = WORLD.floor - 300, line = top + f.derez * 320;
        c.save(); c.beginPath(); c.rect(f.x - 200, line, 400, 400); c.clip();
        this.fighter(f, t, { scale: scaleOf(f) }); c.restore();
        c.save(); c.font = '15px Consolas, monospace';
        for (let i = 0; i < 26; i++) {
          const x = f.x - 70 + noise(i) * 140, fall = ((t * 160 + noise(i + 5) * 300) % 260);
          c.globalAlpha = (1 - fall / 260) * (1 - f.derez * .6); c.fillStyle = i % 4 ? MINT : '#e8fff0';
          c.fillText(glyph(i + Math.floor(t * 20)), x, line - 10 + fall);
        }
        c.globalAlpha = .9; this.line([[f.x - 90, line], [f.x + 90, line]], '#e8fff0', 2);
        c.restore();
      } else this.fighter(f, t, { scale: scaleOf(f), victory: won });
      if (lost) c.restore();
      if (match && f.verdictTime > 0) {
        c.save(); c.textAlign = 'center'; c.globalAlpha = Math.min(f.verdictTime * 2, 1); this.text(f.verdict, f.x, WORLD.floor - 299 - f.y, 15, f.verdict === 'PREDICTED' ? '#ffa566' : f.kind === 'human' ? PILL : MINT); c.restore();
      }
    }
    for (const particle of this.particles) {
      particle.ttl -= dt; particle.x += particle.vx * dt; particle.y += particle.vy * dt; particle.vy += 400 * dt;
      c.globalAlpha = Math.max(0, particle.ttl / particle.max);
      if (particle.glyph) this.text(glyph(particle.seed + Math.floor(particle.vx)), particle.x, particle.y, 14, particle.color);
      else this.line([[particle.x, particle.y], [particle.x - particle.vx * .025, particle.y - particle.vy * .025]], particle.color, 2);
    }
    c.globalAlpha = 1; this.particles = this.particles.filter(p => p.ttl > 0);
    this.evadeFlash = Math.max(0, this.evadeFlash - dt);
    if (this.evadeFlash > 0 && !reduced) {
      // Bullet time: rounds crawl past, dragging rings of displaced air.
      const k = 1 - this.evadeFlash / .9, a = Math.min(1, this.evadeFlash * 2);
      c.save();
      for (let j = 0; j < 3; j++) {
        const y = this.evadeY - 30 + j * 26, x = 80 + ((k * .5 + j * .27) % 1) * 1120;
        c.globalAlpha = a; this.line([[x - 180, y], [x, y]], '#e8fff0', 1);
        for (let r = 1; r <= 5; r++) { c.globalAlpha = a * (.5 - r * .08); this.ring(x - r * 30, y, 3 + r * 1.5, 7 + r * 5, PILL, 1.2); }
        c.globalAlpha = a; this.poly([[x, y - 2.5], [x + 11, y - 2], [x + 15, y], [x + 11, y + 2], [x, y + 2.5]], '#e8d7a0');
      }
      c.restore();
    }
    for (const label of this.labels) { label.ttl -= dt; label.y -= dt * 30; c.save(); c.textAlign = 'center'; c.globalAlpha = Math.max(0, Math.min(1, label.ttl * 2)); this.text(label.text, label.x, label.y, 16, label.color); c.restore(); }
    this.labels = this.labels.filter(l => l.ttl > 0);
    c.restore();
    this.superFlash = Math.max(0, this.superFlash - dt * 1.6);
    if (this.superFlash > 0 && !reduced) { c.fillStyle = this.superKind === 'human' ? `rgba(255,79,195,${this.superFlash * .09})` : `rgba(85,255,138,${this.superFlash * .09})`; c.fillRect(-400, 0, 2100, 720); }
    this.flash = Math.max(0, this.flash - dt);
    if (this.flash > 0 && !reduced) { c.fillStyle = `rgba(235,255,240,${Math.min(.8, this.flash * 3)})`; c.fillRect(-400, 0, 2100, 720); }
    // Vignette leaves the action bright while placing the screen inside an old CRT.
    const vignette = c.createRadialGradient(640, 360, 310, 640, 360, 770); vignette.addColorStop(0, '#0000'); vignette.addColorStop(1, '#000a');
    c.fillStyle = vignette; c.fillRect(-400, 0, 2100, 720);
  }
}


class Sound {
  constructor() { this.enabled = true; this.ctx = null; this.next = 0; this.step = 0; }
  // Must run inside a real gesture, synchronously (every tap calls it, not just the first).
  unlock() {
    if (!this.enabled) return;
    try {
      if (!this.ctx) {
        this.ctx = new (window.AudioContext || window.webkitAudioContext)();
        this.master = this.ctx.createGain(); this.master.gain.value = .21; this.route(this.master);
        this.noise = this.ctx.createBuffer(1, this.ctx.sampleRate * .2, this.ctx.sampleRate);
        const data = this.noise.getChannelData(0); for (let i = 0; i < data.length; i++) data[i] = Math.random() * 2 - 1;
        // iOS parks the context on any interruption (a call, Siri, backgrounding).
        this.ctx.addEventListener?.('statechange', () => { if (this.ctx.state !== 'running' && !document.hidden) this.ctx.resume?.()?.catch?.(() => {}); });
      }
      // Not just 'suspended': iOS also reports a non-standard 'interrupted'.
      if (this.ctx.state !== 'running') this.ctx.resume?.()?.catch?.(() => {});
      // The <audio> sink has its own autoplay gate and must be (re)started from a gesture.
      if (this.sink && this.sink.paused) this.sink.play()?.catch?.(() => {});
      if (!this.opened) {
        // iOS only truly opens output once a source has been started in a gesture.
        this.opened = true;
        const src = this.ctx.createBufferSource(); src.buffer = this.ctx.createBuffer(1, 1, 22050); src.connect(this.ctx.destination); src.start(0);
      }
    } catch { /* Sound is decoration; the game plays on without it. */ }
  }
  /*
   * Where the mix goes. On iOS, WebAudio counts as UI sound and is silenced by
   * the ringer switch, while an <audio> element counts as media and plays anyway.
   * So on iOS the mix is piped through a MediaStream into an <audio> element (the
   * same fix as the Anemoia Boy console, anemoia-gameboy.js routeOutput).
   * Everywhere else the direct connection already works and is left alone.
   */
  route(node) {
    const iOS = /iP(hone|ad|od)/.test(navigator.platform || '') || (/Mac/.test(navigator.userAgent || '') && 'ontouchend' in document);
    if (iOS && this.ctx.createMediaStreamDestination) {
      try {
        const dest = this.ctx.createMediaStreamDestination();
        node.connect(dest);
        this.sink = Object.assign(document.createElement('audio'), { srcObject: dest.stream, playsInline: true, hidden: true });
        this.sink.setAttribute('playsinline', ''); document.body.append(this.sink);
        return;
      } catch { this.sink = null; }
    }
    node.connect(this.ctx.destination);
  }
  setEnabled(enabled) { this.enabled = enabled; if (this.master) this.master.gain.setTargetAtTime(enabled ? .21 : 0, this.ctx.currentTime, .05); if (enabled) this.unlock(); }
  tone(frequency, length = .1, type = 'sine', volume = .2, end = frequency, delay = 0) {
    if (!this.ctx || !this.enabled) return;
    const now = this.ctx.currentTime + delay, osc = this.ctx.createOscillator(), gain = this.ctx.createGain();
    osc.type = type; osc.frequency.setValueAtTime(frequency, now); osc.frequency.exponentialRampToValueAtTime(Math.max(end, 15), now + length);
    gain.gain.setValueAtTime(volume, now); gain.gain.exponentialRampToValueAtTime(.001, now + length);
    osc.connect(gain); gain.connect(this.master); osc.start(now); osc.stop(now + length + .02);
  }
  hiss(length = .06, volume = .1, frequency = 1200) {
    if (!this.ctx || !this.enabled) return;
    const now = this.ctx.currentTime, source = this.ctx.createBufferSource(), filter = this.ctx.createBiquadFilter(), gain = this.ctx.createGain();
    source.buffer = this.noise; filter.type = 'highpass'; filter.frequency.value = frequency;
    gain.gain.setValueAtTime(volume, now); gain.gain.exponentialRampToValueAtTime(.001, now + length);
    source.connect(filter); filter.connect(gain); gain.connect(this.master); source.start(); source.stop(now + length);
  }
  event(e) {
    if (e.type === 'hit') {
      this.tone(e.move === 'super' || e.move === 'power' ? 60 : 130, .17, 'triangle', .65, 25);
      if (e.kind === 'human') { this.hiss(e.move === 'light' ? .07 : .13, .36, e.move === 'light' ? 1300 : 600); this.tone(e.move === 'light' ? 420 : 240, .09, 'triangle', .13, 110); }
      else this.hiss(.11, .7, 750);
    }
    if (e.type === 'block') { this.tone(e.predicted ? 1040 : 720, .11, 'square', .09, 220); this.hiss(.045, .23, 1800); }
    if (e.type === 'attack') {
      if (e.kind !== 'human') {
        if (e.move === 'special') [0, .09, .18].forEach(d => this.gunshot(d + .12));
        else this.hiss(.055, .06, 2500);
      } else { this.hiss(e.move === 'light' ? .07 : .15, .17, e.move === 'light' ? 1500 : 700); this.tone(e.move === 'light' ? 260 : 160, .12, 'sine', .08, 520); }
    }
    if (e.type === 'super') { this.tone(70, .75, 'sawtooth', .22, 680); this.tone(145, .8, 'triangle', .32, 1250); }
    if (e.type === 'power') this.power(e.power, e.finishing);
    if (e.type === 'critical') [880, 660, 880, 660].forEach((n, i) => this.tone(n, .12, 'square', .09, n, i * .14));
    if (e.type === 'finisher') { this.tone(45, 2.2, 'sine', .7, 20); this.tone(1400, 1.6, 'sawtooth', .08, 60, .05); this.hiss(1.2, .35, 200); }
    if (e.type === 'fight' || e.type === 'round') { this.tone(220, .12, 'square', .15); this.tone(440, .22, 'square', .13, 440, .16); }
    if (e.type === 'ko') { this.tone(185, .7, 'sawtooth', .25, 25); this.hiss(.18, .45, 400); }
    if (e.type === 'jump') this.tone(120, .11, 'triangle', .09, 250);
    if (e.type === 'prize') [523.25, 659.25, 783.99, 1046.5].forEach((n, i) => this.tone(n, .5, 'triangle', .14, n, i * .11));
  }
  // Each power quotes its own world. The Fifth is the real motif: G G G E-flat.
  power(id, finishing) {
    const at = (notes, type = 'triangle', vol = .16) => notes.forEach(([n, d, len]) => this.tone(n, len, type, vol, n * .999, d));
    if (id === 'fifth') { at([[392, .1, .18], [392, .4, .18], [392, .7, .18], [311.13, 1.0, 1.1]], 'sawtooth', .13); at([[196, .1, .18], [196, .4, .18], [196, .7, .18], [155.56, 1.0, 1.1]], 'triangle', .2); }
    if (id === 'wave') { this.hiss(1.4, .3, 250); this.tone(60, 1.4, 'sine', .4, 35); this.hiss(.6, .25, 1600); }
    if (id === 'starry') at([[523.25, 0, .6], [659.25, .12, .6], [783.99, .24, .6], [987.77, .36, .6], [1174.66, .48, .9], [1567.98, .6, 1.2]], 'sine', .12);
    if (id === 'vitruvian') { at([[130.81, 0, 1.6], [196, .05, 1.6], [261.63, .1, 1.6], [329.63, .15, 1.6]], 'triangle', .12); this.hiss(.2, .15, 3000); }
    if (id === 'scream') { this.tone(900, 1.3, 'sawtooth', .1, 180); this.tone(600, 1.3, 'triangle', .12, 90, .1); }
    if (id === 'hands') [0, .2, .4, .55, .7, .85, 1.0].forEach(d => { this.tone(70, .2, 'sine', .5, 40, d); });
    if (finishing) this.tone(55, 1.8, 'sawtooth', .12, 30, .3);
  }
  gunshot(delay = 0) {
    if (!this.ctx || !this.enabled) return;
    const now = this.ctx.currentTime + delay, source = this.ctx.createBufferSource(), filter = this.ctx.createBiquadFilter(), gain = this.ctx.createGain();
    source.buffer = this.noise; filter.type = 'lowpass'; filter.frequency.value = 2400;
    gain.gain.setValueAtTime(.6, now); gain.gain.exponentialRampToValueAtTime(.001, now + .12);
    source.connect(filter); filter.connect(gain); gain.connect(this.master); source.start(now); source.stop(now + .14);
    this.tone(160, .1, 'square', .16, 40, delay);
  }
  click() { this.tone(680, .05, 'square', .10, 940); }
  update(active = false) {
    if (!this.ctx || !this.enabled || this.ctx.state !== 'running') return;
    const now = this.ctx.currentTime;
    if (now < this.next) return;
    this.next = now + .137; const s = this.step++ % 32;
    if (s % 4 === 0) this.tone(100, .13, 'sine', active ? .42 : .23, 32);
    if (s % 8 === 4) this.hiss(.075, active ? .13 : .06, 1450);
    if (s % 2 === 0) this.hiss(.025, .045, 6500);
    if ([0, 3, 6, 10, 16, 19, 22, 26, 29].includes(s)) {
      const notes = [55, 55, 65.4, 55, 49, 55, 73.4, 65.4];
      this.tone(notes[Math.floor(s / 4)], .12, 'sawtooth', active ? .105 : .06, notes[Math.floor(s / 4)] * .998);
    }
    if (s === 0) this.tone(110, 1.7, 'sine', .09, 109);
  }
}


// Touch pad. Hold buttons (data-hold) stay down while a finger is on them;
// press buttons (data-press) fire once on touch-down. Several fingers at once are fine.
class TouchControls {
  constructor(buttons, { active, press, unlock, held }) {
    Object.assign(this, { active, press, unlock, held });
    this.pointers = new Map();
    for (const button of buttons) {
      button.addEventListener('pointerdown', event => this.down(button, event));
      for (const type of ['pointerup', 'pointercancel', 'lostpointercapture']) button.addEventListener(type, event => this.release(event));
      button.addEventListener('contextmenu', event => event.preventDefault());
    }
  }
  down(button, event) {
    event.preventDefault();
    if (!this.active() || button.disabled || this.pointers.has(event.pointerId)) return;
    button.setPointerCapture?.(event.pointerId); this.unlock(); button.classList.add('held');
    this.pointers.set(event.pointerId, button);
    if (button.dataset.hold) this.held.add(button.dataset.hold);
    else if (button.dataset.press) this.press(button.dataset.press);
  }
  release(event) {
    const button = this.pointers.get(event.pointerId); if (!button) return;
    this.pointers.delete(event.pointerId);
    if (![...this.pointers.values()].includes(button)) button.classList.remove('held');
    this.held.clear(); for (const b of this.pointers.values()) if (b.dataset.hold) this.held.add(b.dataset.hold);
  }
  clear() {
    for (const button of this.pointers.values()) button.classList.remove('held');
    this.pointers.clear(); this.held.clear();
  }
}



const $ = id => document.getElementById(id);
// Reward. The same single offer and the same lightly-obfuscated code as the other
// NFC pages (page.nfc.liquid PRIZE, anemoia-paint.js PRIZE): every tag lands on
// one consistent payoff, and the tags only reach people who have already bought.
const _p = s => atob(s.split('').reverse().join(''));
const PRIZE = { line: 'YOU WON $10 OFF YOUR NEXT ORDER', code: _p('=QWYlJnQ') };
const text = (id, value) => { if ($(id).textContent !== String(value)) $(id).textContent = value; };
const renderer = new Renderer($('arena'));
const sound = new Sound();
const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
let muted = false;
try { muted = localStorage.getItem('anemoia-fight-muted') === '1'; } catch { /* Private browsing still gets a playable game. */ }
sound.enabled = !muted;

let screen = 'boot', match = null, paused = false, bannerHold = 0, calloutTime = 0, bootTimer;
const keys = new Set(), held = new Set();
let pressed = [];
const keymap = {
  ArrowLeft: 'left', KeyA: 'left', ArrowRight: 'right', KeyD: 'right',
  ArrowUp: 'jump', KeyW: 'jump', ArrowDown: 'block', KeyS: 'block', Space: 'strike', KeyJ: 'strike', KeyK: 'strike',
  KeyE: 'dodge', KeyL: 'dodge', ShiftLeft: 'dodge', ShiftRight: 'dodge',
  Digit1: 'power:0', Numpad1: 'power:0', Digit2: 'power:1', Numpad2: 'power:1', Digit3: 'power:2', Numpad3: 'power:2',
};
const continuous = ['left', 'right', 'block'];

function clearInput() { keys.clear(); held.clear(); pressed = []; touch?.clear(); }
function setScreen(next) {
  screen = next; clearInput();
  for (const name of ['boot', 'home', 'result']) $(name).hidden = name !== next;
  document.body.dataset.screen = next;
  $('pad').hidden = next !== 'game';
  $('hud').hidden = next !== 'game';
  $('controls').hidden = true;
  if (next !== 'game') { paused = false; $('pause').hidden = true; $('finish').hidden = true; $('callout').hidden = true; $('banner').hidden = true; }
  requestAnimationFrame(() => { renderer.resize(); $(next)?.querySelector('.primary')?.focus({ preventScroll: true }); });
}
function home() { clearTimeout(bootTimer); match = null; setScreen('home'); }
// Portrait phones get a taller view of the middle of the arena; the fight is kept inside it.
function narrow() { const s = $('stage'); return s.clientWidth / s.clientHeight < 1.5; }
function drawHand() {
  match.hand.forEach((id, i) => {
    const button = document.querySelector(`[data-slot="${i}"]`);
    if (button.dataset.power !== id) {
      button.dataset.power = id; button.style.setProperty('--power', POWERS[id].color);
      button.querySelector('b').textContent = POWERS[id].name;
      renderer.icon(button.querySelector('canvas'), id);
      button.classList.remove('dealt'); void button.offsetWidth; button.classList.add('dealt');
    }
  });
}
function play() {
  sound.unlock(); clearTimeout(bootTimer);
  match = new Match({ narrow: narrow() });
  renderer.particles = []; renderer.labels = []; renderer.rings = []; renderer.powerFx = null; renderer.koFx = null; renderer.zoom = 1;
  document.querySelectorAll('[data-slot]').forEach(b => { b.dataset.power = ''; });
  setScreen('game'); drawHand(); updateHUD();
}
function togglePause(force) {
  if (screen !== 'game') return;
  paused = typeof force === 'boolean' ? force : !paused; clearInput();
  $('pause').hidden = !paused;
  if (paused) $('resume').focus({ preventScroll: true });
}
function result() {
  const won = match.winner === 0;
  text('result-kicker', won ? 'HUMAN VERIFIED' : 'MATCH LOST');
  $('result-title').replaceChildren(won ? 'YOU BEAT' : 'THE MACHINE', document.createElement('br'), Object.assign(document.createElement('em'), { textContent: won ? 'THE MACHINE.' : 'LEARNED YOU.' }));
  text('result-line', won ? 'Natural intelligence wins. No model saw that coming.' : 'It only won by learning your habits. Change them and run it back.');
  text('result-score', `${match.fighters[0].wins} / ${match.fighters[1].wins}`);
  // Beat the machine, win the prize. Losing still shows the way to claim the tag.
  $('prize-box').hidden = !won;
  if (won) { text('prize-line', PRIZE.line); text('prize-code', PRIZE.code); }
  setScreen('result');
  if (won) sound.event({ type: 'prize' });
}
function banner(main, sub = '', dramatic = false) {
  text('banner-main', main); text('banner-sub', sub);
  $('banner').hidden = !main;
  $('banner').classList.toggle('dramatic', dramatic);
}
function handleEvent(event) {
  renderer.event(event); sound.event(event);
  if (event.type === 'hand') drawHand();
  if (event.type === 'power') {
    const p = POWERS[event.power];
    text('callout-name', p.name); text('callout-by', p.by);
    $('callout').style.setProperty('--power', p.color);
    $('callout').hidden = false; calloutTime = event.finishing ? 3.6 : 1.7;
  }
  if (event.type === 'fight') bannerHold = .5;
  if (event.type === 'matchEnd') setTimeout(result, 300);
}
function updateHUD() {
  if (!match) return;
  const [neo, agent] = match.fighters;
  $('p1-health').style.width = `${neo.health}%`; $('p2-health').style.width = `${agent.health}%`;
  $('p1-health').parentElement.classList.toggle('low', neo.health <= 25);
  $('p2-health').parentElement.classList.toggle('low', agent.health <= 25);
  text('p1-wins', `${neo.wins > 0 ? '●' : '○'}${neo.wins > 1 ? '●' : '○'}`);
  text('p2-wins', `${agent.wins > 0 ? '●' : '○'}${agent.wins > 1 ? '●' : '○'}`);
  text('timer', String(Math.ceil(match.timer)).padStart(2, '0'));
  text('round-label', `ROUND ${match.round} · ${STAGES[(match.round - 1) % STAGES.length].name}`);
  const bars = Math.floor(neo.meter / POWER_COST);
  document.querySelectorAll('#meter i').forEach((bar, i) => {
    const fill = Math.max(0, Math.min(1, (neo.meter - i * POWER_COST) / POWER_COST));
    bar.style.setProperty('--fill', fill); bar.classList.toggle('full', fill >= 1);
  });
  const cool = neo.dodgeCooldown > 0;
  $('dodge-btn').style.setProperty('--charge', `${100 * (1 - neo.dodgeCooldown / DODGE.cooldown)}%`);
  $('dodge-btn').classList.toggle('cooling', cool);
  const fighting = match.phase === 'fight';
  const ready = fighting && bars > 0 && !neo.action && neo.stun <= 0;
  document.querySelectorAll('[data-slot]').forEach(b => { b.disabled = !ready; });
  const finishing = ready && match.critical;
  $('finish').hidden = !finishing;
  $('pad').classList.toggle('finish-ready', finishing);
  // Round banners.
  if (match.phase === 'intro') banner(match.phaseTime > .6 ? `ROUND ${match.round}` : 'FIGHT', match.phaseTime > .6 ? 'BEAT AI WITH YOUR NATURAL INTELLIGENCE' : '');
  else if (match.phase === 'finisher') {
    const t = match.finisher.time;
    banner(t > 2.1 ? 'K.O.' : '', t > 2.1 ? 'NATURAL INTELLIGENCE WINS' : '', true);
  } else if (match.phase === 'roundEnd') {
    if (match.finisher) banner('K.O.', 'NATURAL INTELLIGENCE WINS', true);
    else banner(match.timer <= 0 ? 'TIME' : 'K.O.', match.roundWinner === null ? 'DRAW' : match.roundWinner === 0 ? 'NEO TAKES THE ROUND' : 'THE AGENT TAKES THE ROUND');
  } else if (bannerHold > 0) banner('FIGHT');
  else banner('');
  if (calloutTime <= 0 || (match.phase === 'finisher' && match.finisher.time > 2.1) || match.phase === 'roundEnd') $('callout').hidden = true;
}

// Boot: the terminal types itself in CSS (it runs before this script arrives); this only hands over to home.
bootTimer = setTimeout(() => { if (screen === 'boot') home(); }, reduced ? 1500 : 6800);
$('boot').addEventListener('click', home);
$('play').addEventListener('click', play);
$('again').addEventListener('click', play);
$('pause-btn').addEventListener('click', () => togglePause());
$('copy-btn').addEventListener('click', async () => {
  const code = $('prize-code').textContent;
  try { await navigator.clipboard.writeText(code); text('copy-btn', 'COPIED ✓'); }
  catch {
    // Older iOS Safari.
    const ta = Object.assign(document.createElement('textarea'), { value: code });
    document.body.append(ta); ta.select();
    try { document.execCommand('copy'); text('copy-btn', 'COPIED ✓'); } catch { text('copy-btn', code); }
    ta.remove();
  }
  setTimeout(() => text('copy-btn', 'COPY CODE'), 1600);
});
$('resume').addEventListener('click', () => togglePause(false));
$('quit').addEventListener('click', home);
// The controls card opens from home, the pause menu and the top bar; in a fight it pauses first.
let controlsFrom = null;
function openControls() {
  controlsFrom = document.activeElement;
  if (screen === 'game' && !paused) togglePause(true);
  $('controls').hidden = false; $('controls-close').focus({ preventScroll: true });
}
function closeControls() {
  $('controls').hidden = true;
  if (controlsFrom instanceof HTMLElement && !controlsFrom.closest('[hidden]')) controlsFrom.focus({ preventScroll: true });
}
document.querySelectorAll('[data-controls]').forEach(b => b.addEventListener('click', openControls));
$('controls-close').addEventListener('click', closeControls);
function applySound() { text('sound-state', muted ? 'OFF' : 'ON'); $('sound').setAttribute('aria-pressed', String(!muted)); }
$('sound').addEventListener('click', () => {
  muted = !muted; sound.setEnabled(!muted); applySound();
  try { localStorage.setItem('anemoia-fight-muted', muted ? '1' : '0'); } catch { /* Stays in memory. */ }
});
applySound();
document.addEventListener('click', e => { if (e.target.closest('button')) { sound.unlock(); sound.click(); } });
// Every gesture re-wakes the audio, not just button clicks: iOS re-gates the
// <audio> sink after any interruption, and touchend/click are the gestures it
// trusts. The pad's pointerdown alone would not count.
['touchend', 'click', 'keydown'].forEach(type => window.addEventListener(type, () => sound.unlock(), { passive: true }));
document.querySelectorAll('[data-slot]').forEach(b => b.addEventListener('click', e => {
  if (e.detail === 0 && screen === 'game' && !paused) pressed.push(`power:${b.dataset.slot}`);
}));

window.addEventListener('keydown', e => {
  if (e.code === 'Escape') { e.preventDefault(); if (!$('controls').hidden) closeControls(); else if (screen === 'game') togglePause(); return; }
  if (!$('controls').hidden) return;
  if (screen === 'boot') { home(); return; }
  if ((screen === 'home' || screen === 'result') && (e.code === 'Enter' || e.code === 'Space')) { e.preventDefault(); play(); return; }
  if (screen !== 'game' || paused) return;
  const action = keymap[e.code]; if (!action) return;
  e.preventDefault(); sound.unlock();
  if (!keys.has(e.code) && !e.repeat && !continuous.includes(action)) pressed.push(action);
  keys.add(e.code);
});
window.addEventListener('keyup', e => { keys.delete(e.code); });
window.addEventListener('blur', () => { clearInput(); if (screen === 'game') togglePause(true); });
document.addEventListener('visibilitychange', () => { if (document.hidden) { clearInput(); if (screen === 'game') togglePause(true); } });
window.addEventListener('resize', () => renderer.resize());
new ResizeObserver(() => renderer.resize()).observe($('stage'));
const touch = new TouchControls(document.querySelectorAll('#pad button'), {
  active: () => screen === 'game' && !paused,
  press: action => pressed.push(action), unlock: () => sound.unlock(), held,
});
function input() {
  const state = { left: false, right: false, block: false, pressed: pressed.splice(0) };
  for (const code of keys) { const action = keymap[code]; if (continuous.includes(action)) state[action] = true; }
  for (const action of held) state[action] = true;
  return state;
}
let last = performance.now(), accumulator = 0;
function frame(now) {
  const dt = Math.min((now - last) / 1000, .05); last = now;
  if (screen === 'game' && !paused) {
    accumulator += dt;
    while (accumulator >= 1 / 120) { match.tick(1 / 120, input()); match.drainEvents().forEach(handleEvent); accumulator -= 1 / 120; }
    calloutTime = Math.max(0, calloutTime - dt); bannerHold = Math.max(0, bannerHold - dt);
    updateHUD();
  } else accumulator = 0;
  renderer.draw(['game', 'result'].includes(screen) ? match : null, paused ? 0 : dt, { boot: screen === 'boot', menu: screen === 'home', reduced });
  sound.update(screen === 'game' && !paused);
  requestAnimationFrame(frame);
}
requestAnimationFrame(frame);

})();
